var _defs, _path, _g, _path2, _path3, _path4, _path5, _g2, _g3, _path6, _line, _path7, _line2, _path8, _line3, _rect, _line4, _rect2, _line5, _rect3, _line6, _path9, _path0, _line7, _path1, _line8, _rect4, _line9, _path10, _line0, _rect5, _line1, _path11, _line10, _rect6, _path12, _line11, _path13, _line12, _path14, _line13, _rect7, _line14, _path15, _line15, _path16, _line16, _rect8, _g4, _rect9, _path17, _g5, _rect0, _path18, _rect1, _rect10, _rect11, _path19, _rect12, _path20, _rect13, _path21, _rect14, _path22, _rect15, _path23, _rect16, _path24, _rect17, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g6, _path101, _path102, _g7, _path103, _path104, _g8, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3ResumeBuildingDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88107",
    "data-name": "Group 88107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 440.947,
    height: 403.029,
    viewBox: "0 0 440.947 403.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25517",
    "data-name": "Rectangle 25517",
    width: 440.947,
    height: 403.029,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25488",
    "data-name": "Rectangle 25488",
    width: 113.012,
    height: 146.112,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25487",
    "data-name": "Rectangle 25487",
    width: 97.354,
    height: 111.27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25489",
    "data-name": "Rectangle 25489",
    width: 113.036,
    height: 143.049,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25490",
    "data-name": "Rectangle 25490",
    width: 39.76,
    height: 143.53,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25499",
    "data-name": "Rectangle 25499",
    width: 115.459,
    height: 128.983,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25502",
    "data-name": "Rectangle 25502",
    width: 42.24,
    height: 340.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25513",
    "data-name": "Rectangle 25513",
    width: 17.108,
    height: 17.717,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25514",
    "data-name": "Rectangle 25514",
    width: 7.569,
    height: 9.438,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25515",
    "data-name": "Rectangle 25515",
    width: 23.317,
    height: 45.412,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87895",
    "data-name": "Group 87895",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87894",
    "data-name": "Group 87894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87893",
    "data-name": "Group 87893",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_276275",
    "data-name": "Path 276275",
    d: "M382.453,147.911c0,6.887-81.12,12.473-181.187,12.473S20.08,154.8,20.08,147.911s81.12-12.473,181.187-12.473,181.187,5.583,181.187,12.473",
    transform: "translate(35.975 242.646)",
    fill: "#515255",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87871",
    "data-name": "Group 87871",
    transform: "translate(31.61 160.564)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87870",
    "data-name": "Group 87870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87869",
    "data-name": "Group 87869",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276276",
    "data-name": "Path 276276",
    d: "M61.1,193.544c-.748-3.626-1.75-8.833-2.663-15.122-.268-1.815-.522-3.741-.762-5.723.812-.154,7.294-1.421,9.821-3.21,2.3-1.622,4.771-4.33,4.866-7.3a4.988,4.988,0,0,0-5.187-5.312c-4.2.29-8.1,6.82-9,10.474-.059.235-.43,3.076-.589,4.531-.142-1.2-.285-2.387-.413-3.637-.2-1.8-.343-3.7-.5-5.55q-.067-1.44-.137-2.909c-.067-.988-.008-1.935-.02-2.92.014-1.44.1-2.926.187-4.408,1.84-.089,7.241-.444,9.676-1.661,2.515-1.256,5.371-3.556,5.915-6.482a4.989,4.989,0,0,0-4.321-6.038c-4.2-.349-9.039,5.516-10.485,8.992-.047.112-.276.877-.542,1.789.128-1.446.248-2.889.424-4.349.5-4.14,1.142-8.344,1.764-12.559.131-.879.246-1.759.374-2.638,1.549-.067,7.4-.4,9.955-1.672,2.515-1.259,5.371-3.559,5.913-6.485a4.988,4.988,0,0,0-4.319-6.038c-4.2-.346-9.039,5.516-10.488,8.992-.05.126-.324,1.041-.617,2.069.3-2.295.581-4.587.784-6.87a88.547,88.547,0,0,0,.329-11.778c.547-.02,7.417-.271,10.253-1.686,2.515-1.259,5.371-3.559,5.915-6.485a4.99,4.99,0,0,0-4.321-6.038c-4.2-.346-9.039,5.516-10.485,8.992-.1.248-1.064,3.568-1.365,4.762,0-.045,0-.092,0-.137A65.26,65.26,0,0,0,59.3,95.7,88.877,88.877,0,0,0,56.3,85.809c-1.075-3.018-2.242-5.709-3.3-8.082-.581-1.281-1.133-2.443-1.664-3.52l.087.025c.075.02-.126-5.1-.176-5.418-.575-3.721-3.872-10.572-8.034-11.236a4.991,4.991,0,0,0-5.639,4.832c-.17,2.97,2.055,5.885,4.2,7.707,2.194,1.865,7.9,3.607,9.324,4.02.528,1.131,1.078,2.345,1.658,3.7,1,2.392,2.1,5.1,3.11,8.126.268.8.528,1.681.793,2.526-.743-1.332-1.787-3.146-1.909-3.311-2.225-3.037-8.308-7.6-12.308-6.27A4.991,4.991,0,0,0,39.658,85.8c1.22,2.716,4.534,4.277,7.275,4.908,2.859.656,8.869-.477,10.181-.74.556,1.882,1.086,3.83,1.519,5.89a64.416,64.416,0,0,1,1.491,11.323c.006.221-.014.449-.008.67-.251-.723-1.923-4.584-2.071-4.841-1.876-3.261-7.423-8.461-11.546-7.582a4.988,4.988,0,0,0-3.515,6.541c.91,2.833,4.034,4.751,6.691,5.675,3.057,1.069,10.172.388,10.438.363a87.69,87.69,0,0,1-.575,11.381c-.313,2.8-.74,5.619-1.2,8.444-.352-.932-1.907-4.52-2.046-4.765-1.879-3.263-7.426-8.464-11.549-7.582a4.987,4.987,0,0,0-3.515,6.538c.913,2.833,4.037,4.751,6.691,5.678,2.987,1.041,9.8.422,10.379.366-.209,1.284-.41,2.565-.631,3.852-.712,4.193-1.446,8.4-2.043,12.565-.207,1.446-.357,2.875-.514,4.307-.569-1.379-1.653-3.872-1.77-4.076-1.879-3.263-7.426-8.464-11.549-7.582a4.988,4.988,0,0,0-3.515,6.538c.913,2.833,4.037,4.751,6.691,5.678s8.411.533,10.027.4c-.246,2.387-.433,4.76-.508,7.1-.011,1.013-.087,2.043-.042,3.015.025.98.047,1.951.073,2.912.12,1.985.223,3.833.382,5.675.075.935.165,1.815.248,2.719-.368-1.485-.988-3.83-1.069-4.037-1.36-3.509-6.055-9.488-10.265-9.243a4.992,4.992,0,0,0-4.467,5.932c.475,2.937,3.272,5.307,5.756,6.624,2.739,1.452,9.346,1.884,10.153,1.932.215,2.216.447,4.372.7,6.384.784,6.37,1.681,11.646,2.359,15.331s1.156,5.792,1.156,5.792l.006.02.006.025a1.48,1.48,0,0,0,2.873-.717s-.508-2.029-1.259-5.664",
    transform: "translate(35.688 -57.518)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276277",
    "data-name": "Path 276277",
    d: "M44.721,79.759c.006,0,7.085-2.163,9.542-4.366,2.1-1.876,4.24-4.849,3.992-7.814A4.987,4.987,0,0,0,52.493,62.9c-4.143.773-7.261,7.708-7.738,11.44-.042.324-.106,5.444-.033,5.421",
    transform: "translate(48.452 -48.026)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276278",
    "data-name": "Path 276278",
    d: "M108.2,178.7a1.48,1.48,0,0,1-2,2.183l-.02-.02-.014-.011s-1.563-1.5-4.159-4.2-6.256-6.6-10.426-11.487c-1.32-1.538-2.7-3.21-4.1-4.938-.7.4-6.449,3.69-9.533,3.989-2.8.271-6.44-.162-8.456-2.351a4.99,4.99,0,0,1,.455-7.412c3.372-2.526,10.588-.128,13.659,2.049.181.128,1.993,1.739,3.118,2.775-.569-.709-1.131-1.39-1.706-2.13-1.15-1.449-2.256-2.931-3.45-4.522q-.829-1.181-1.669-2.387c-.572-.784-1.078-1.689-1.627-2.538-1.231-2-2.381-4.081-3.492-6.206-1.276,1-5.846,4.506-8.584,5.2s-6.39.818-8.712-1.041a4.99,4.99,0,0,1-.676-7.395c2.953-3.009,10.449-1.731,13.815-.045.209.1,2.487,1.586,3.724,2.423-.659-1.284-1.323-2.56-1.946-3.878-1.8-3.808-3.509-7.716-5.229-11.61-.528-1.192-1.064-2.373-1.6-3.559-.449.363-5.793,4.642-8.86,5.421-2.725.692-6.387.815-8.712-1.044a4.987,4.987,0,0,1-.673-7.392c2.951-3.009,10.446-1.734,13.813-.047.254.128,3.529,2.261,4.335,2.847-1.178-2.61-2.376-5.2-3.66-7.7a88.109,88.109,0,0,0-5.8-9.812c-.209.17-5.767,4.662-8.905,5.458-2.727.692-6.39.818-8.715-1.041a4.99,4.99,0,0,1-.673-7.395c2.951-3.009,10.446-1.731,13.813-.045.265.131,3.788,2.432,4.4,2.892-.126-.181-.234-.382-.363-.561a64.269,64.269,0,0,0-7.49-8.623c-1.5-1.48-3.012-2.811-4.517-4.076-.949.944-5.335,5.2-8.082,6.234-2.632.988-6.261,1.513-8.774-.081a4.989,4.989,0,0,1-1.485-7.275c2.6-3.314,10.195-2.867,13.726-1.56.193.07,2.063,1.008,3.417,1.708-.687-.558-1.385-1.147-2.055-1.672-2.507-1.968-4.924-3.618-7.077-5.061-1.231-.81-2.359-1.519-3.422-2.169-1.413.438-7.135,2.136-9.994,1.789-2.792-.335-6.256-1.541-7.752-4.115A4.987,4.987,0,0,1,14.1,71.13c3.838-1.742,10.368,2.152,12.9,4.938.218.24,3.208,4.4,3.135,4.422,0,0-.07.022-.087.025,1.036.609,2.141,1.27,3.33,2.018,2.189,1.4,4.648,3,7.208,4.922a88.739,88.739,0,0,1,7.964,6.594,65.2,65.2,0,0,1,7.772,8.567c.028.036.05.078.078.114-.408-1.164-1.438-4.464-1.488-4.726C54.2,94.309,55,86.749,58.7,84.72a4.988,4.988,0,0,1,6.934,2.655c1.161,2.739.047,6.234-1.357,8.668-1.583,2.747-7.174,6.747-7.621,7.065a88.7,88.7,0,0,1,6.222,10c1.089,2.016,2.122,4.081,3.135,6.161-.321-1.019-.6-1.932-.625-2.063-.709-3.7.089-11.258,3.785-13.285a4.989,4.989,0,0,1,6.934,2.652c1.161,2.741.05,6.234-1.354,8.671-1.426,2.47-6.125,5.977-7.381,6.887.38.8.768,1.6,1.142,2.406,1.806,3.858,3.593,7.719,5.46,11.448.656,1.318,1.354,2.588,2.043,3.861-.282-.9-.514-1.669-.536-1.789-.712-3.7.089-11.258,3.785-13.285a4.989,4.989,0,0,1,6.934,2.652c1.161,2.741.047,6.234-1.357,8.671-1.359,2.359-5.667,5.633-7.155,6.722.748,1.284,1.493,2.571,2.275,3.783.553.812,1.03,1.636,1.63,2.423q.867,1.185,1.717,2.35c1.147,1.454,2.323,2.962,3.478,4.355.8.971,1.572,1.884,2.351,2.805-.67-1.3-1.929-3.875-2.01-4.1-1.262-3.545-1.616-11.141,1.731-13.7a4.991,4.991,0,0,1,7.258,1.572c1.56,2.532.991,6.153-.028,8.774-1.122,2.887-5.832,7.52-6.423,8.1,1.3,1.521,2.571,2.987,3.794,4.352,4.232,4.743,7.939,8.534,10.563,11.144S108.2,178.7,108.2,178.7M43.475,89.672c0-.006,4.715-5.712,5.552-8.905.709-2.722.86-6.384-.983-8.721a4.99,4.99,0,0,0-7.389-.726c-3.029,2.931-1.8,10.435-.142,13.813.142.29,2.914,4.6,2.962,4.539",
    transform: "translate(-11.323 -35.157)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87868",
    "data-name": "Group 87868",
    transform: "translate(0 34.842)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87867",
    "data-name": "Group 87867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87866",
    "data-name": "Group 87866",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276279",
    "data-name": "Path 276279",
    d: "M108.2,178.7a1.48,1.48,0,0,1-2,2.183l-.02-.02-.014-.011s-1.563-1.5-4.159-4.2-6.256-6.6-10.426-11.487c-1.32-1.538-2.7-3.21-4.1-4.938-.7.4-6.449,3.69-9.533,3.989-2.8.271-6.44-.162-8.456-2.351a4.99,4.99,0,0,1,.455-7.412c3.372-2.526,10.588-.128,13.659,2.049.181.128,1.993,1.739,3.118,2.775-.569-.709-1.131-1.39-1.706-2.13-1.15-1.449-2.256-2.931-3.45-4.522q-.829-1.181-1.669-2.387c-.572-.784-1.078-1.689-1.627-2.538-1.231-2-2.381-4.081-3.492-6.206-1.276,1-5.846,4.506-8.584,5.2s-6.39.818-8.712-1.041a4.99,4.99,0,0,1-.676-7.395c2.953-3.009,10.449-1.731,13.815-.045.209.1,2.487,1.586,3.724,2.423-.659-1.284-1.323-2.56-1.946-3.878-1.8-3.808-3.509-7.716-5.229-11.61-.528-1.192-1.064-2.373-1.6-3.559-.449.363-5.793,4.642-8.86,5.421-2.725.692-6.387.815-8.712-1.044a4.987,4.987,0,0,1-.673-7.392c2.951-3.009,10.446-1.734,13.813-.047.254.128,3.529,2.261,4.335,2.847-1.178-2.61-2.376-5.2-3.66-7.7a88.109,88.109,0,0,0-5.8-9.812c-.209.17-5.767,4.662-8.905,5.458-2.727.692-6.39.818-8.715-1.041a4.99,4.99,0,0,1-.673-7.395c2.951-3.009,10.446-1.731,13.813-.045.265.131,3.788,2.432,4.4,2.892-.126-.181-.234-.382-.363-.561a64.269,64.269,0,0,0-7.49-8.623c-1.5-1.48-3.012-2.811-4.517-4.076-.949.944-5.335,5.2-8.082,6.234-2.632.988-6.261,1.513-8.774-.081a4.989,4.989,0,0,1-1.485-7.275c2.6-3.314,10.195-2.867,13.726-1.56.193.07,2.063,1.008,3.417,1.708-.687-.558-1.385-1.147-2.055-1.672-2.507-1.968-4.924-3.618-7.077-5.061-1.231-.81-2.359-1.519-3.422-2.169-1.413.438-7.135,2.136-9.994,1.789-2.792-.335-6.256-1.541-7.752-4.115A4.987,4.987,0,0,1,14.1,71.13c3.838-1.742,10.368,2.152,12.9,4.938.218.24,3.208,4.4,3.135,4.422,0,0-.07.022-.087.025,1.036.609,2.141,1.27,3.33,2.018,2.189,1.4,4.648,3,7.208,4.922a88.739,88.739,0,0,1,7.964,6.594,65.2,65.2,0,0,1,7.772,8.567c.028.036.05.078.078.114-.408-1.164-1.438-4.464-1.488-4.726C54.2,94.309,55,86.749,58.7,84.72a4.988,4.988,0,0,1,6.934,2.655c1.161,2.739.047,6.234-1.357,8.668-1.583,2.747-7.174,6.747-7.621,7.065a88.7,88.7,0,0,1,6.222,10c1.089,2.016,2.122,4.081,3.135,6.161-.321-1.019-.6-1.932-.625-2.063-.709-3.7.089-11.258,3.785-13.285a4.989,4.989,0,0,1,6.934,2.652c1.161,2.741.05,6.234-1.354,8.671-1.426,2.47-6.125,5.977-7.381,6.887.38.8.768,1.6,1.142,2.406,1.806,3.858,3.593,7.719,5.46,11.448.656,1.318,1.354,2.588,2.043,3.861-.282-.9-.514-1.669-.536-1.789-.712-3.7.089-11.258,3.785-13.285a4.989,4.989,0,0,1,6.934,2.652c1.161,2.741.047,6.234-1.357,8.671-1.359,2.359-5.667,5.633-7.155,6.722.748,1.284,1.493,2.571,2.275,3.783.553.812,1.03,1.636,1.63,2.423q.867,1.185,1.717,2.35c1.147,1.454,2.323,2.962,3.478,4.355.8.971,1.572,1.884,2.351,2.805-.67-1.3-1.929-3.875-2.01-4.1-1.262-3.545-1.616-11.141,1.731-13.7a4.991,4.991,0,0,1,7.258,1.572c1.56,2.532.991,6.153-.028,8.774-1.122,2.887-5.832,7.52-6.423,8.1,1.3,1.521,2.571,2.987,3.794,4.352,4.232,4.743,7.939,8.534,10.563,11.144S108.2,178.7,108.2,178.7M43.475,89.672c0-.006,4.715-5.712,5.552-8.905.709-2.722.86-6.384-.983-8.721a4.99,4.99,0,0,0-7.389-.726c-3.029,2.931-1.8,10.435-.142,13.813.142.29,2.914,4.6,2.962,4.539",
    transform: "translate(-11.323 -69.999)",
    fill: "#515255"
  })))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276280",
    "data-name": "Path 276280",
    d: "M54.98,220.985c-.91-3.59-2.138-8.746-3.328-14.991-.349-1.8-.687-3.713-1.013-5.684.8-.187,7.225-1.742,9.67-3.637,2.222-1.725,4.573-4.536,4.536-7.512a4.988,4.988,0,0,0-5.413-5.081c-4.19.477-7.791,7.174-8.534,10.865-.047.234-.293,3.09-.388,4.553-.2-1.192-.391-2.376-.572-3.618-.276-1.787-.508-3.685-.743-5.522q-.13-1.436-.265-2.9c-.109-.983-.095-1.935-.151-2.917-.047-1.44-.025-2.928-.006-4.413,1.837-.168,7.216-.762,9.595-2.085,2.457-1.365,5.206-3.788,5.622-6.736a4.993,4.993,0,0,0-4.584-5.843c-4.212-.162-8.788,5.91-10.078,9.447-.042.114-.237.89-.461,1.812.061-1.449.117-2.895.232-4.363.318-4.159.77-8.386,1.206-12.626.092-.882.17-1.767.257-2.649,1.547-.137,7.378-.726,9.874-2.113,2.457-1.365,5.206-3.788,5.622-6.736a4.991,4.991,0,0,0-4.584-5.843c-4.212-.162-8.788,5.91-10.08,9.447-.045.126-.276,1.052-.528,2.091.207-2.306.38-4.606.483-6.9a88.3,88.3,0,0,0-.19-11.783c.544-.042,7.4-.595,10.17-2.136,2.457-1.368,5.206-3.791,5.622-6.739a4.989,4.989,0,0,0-4.584-5.84c-4.212-.165-8.788,5.91-10.078,9.444-.092.251-.9,3.609-1.156,4.818,0-.045,0-.092-.008-.137a64.94,64.94,0,0,0-2.258-11.345,88.237,88.237,0,0,0-3.439-9.751c-1.206-2.965-2.493-5.6-3.649-7.928-.636-1.253-1.242-2.39-1.817-3.442l.087.02c.075.017-.352-5.086-.413-5.4-.74-3.69-4.338-10.39-8.525-10.87a4.99,4.99,0,0,0-5.418,5.075c-.039,2.976,2.311,5.79,4.531,7.515,2.275,1.767,8.054,3.255,9.494,3.607.575,1.105,1.178,2.292,1.817,3.621,1.1,2.345,2.328,5,3.467,7.981.3.793.6,1.658.9,2.49-.8-1.3-1.923-3.065-2.052-3.224-2.356-2.937-8.634-7.222-12.573-5.72a4.988,4.988,0,0,0-2.471,7c1.337,2.66,4.718,4.076,7.484,4.584,2.884.528,8.838-.868,10.136-1.189.639,1.856,1.253,3.777,1.778,5.818a64.207,64.207,0,0,1,1.988,11.247c.017.218.008.449.022.67-.285-.712-2.124-4.494-2.284-4.746-2.018-3.177-7.788-8.126-11.87-7.065a4.993,4.993,0,0,0-3.224,6.689c1.038,2.789,4.243,4.567,6.937,5.377,3.1.93,10.178-.061,10.446-.1a87.891,87.891,0,0,1-.075,11.4c-.187,2.808-.491,5.647-.824,8.492-.391-.916-2.1-4.433-2.256-4.673-2.018-3.177-7.788-8.126-11.87-7.065a4.991,4.991,0,0,0-3.224,6.689c1.038,2.789,4.243,4.567,6.937,5.377,3.029.91,9.815-.011,10.385-.092-.151,1.293-.3,2.582-.461,3.875-.525,4.224-1.075,8.453-1.485,12.646-.142,1.452-.232,2.886-.324,4.327-.631-1.357-1.823-3.8-1.949-3.995-2.021-3.177-7.791-8.129-11.87-7.065a4.986,4.986,0,0,0-3.224,6.686c1.036,2.792,4.24,4.57,6.934,5.377s8.428.162,10.036-.045c-.14,2.4-.223,4.774-.2,7.118.034,1.011,0,2.043.092,3.012q.1,1.466.2,2.906c.207,1.979.394,3.816.634,5.653.114.93.243,1.8.366,2.705-.433-1.468-1.156-3.783-1.245-3.986-1.513-3.445-6.468-9.212-10.661-8.779a4.989,4.989,0,0,0-4.2,6.122c.6,2.914,3.5,5.156,6.041,6.365,2.8,1.329,9.422,1.468,10.231,1.482.313,2.2.636,4.347.977,6.345,1.066,6.331,2.194,11.563,3.034,15.214s1.41,5.737,1.41,5.737l.006.017.006.025a1.481,1.481,0,1,0,2.839-.843s-.595-2.007-1.507-5.6",
    transform: "translate(46.03 153.911)",
    fill: "#ffdbb3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276281",
    "data-name": "Path 276281",
    d: "M33.377,108.141c.006,0,6.982-2.473,9.341-4.782,2.01-1.968,4.023-5.03,3.643-7.984A4.988,4.988,0,0,0,40.4,90.953c-4.106.955-6.915,8.02-7.227,11.769-.025.327.134,5.444.207,5.418",
    transform: "translate(59.423 162.722)",
    fill: "#ffdbb3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276282",
    "data-name": "Path 276282",
    d: "M96.988,199.02c-2.739-2.493-6.608-6.116-11.043-10.667-1.284-1.309-2.621-2.719-3.984-4.182.567-.6,5.067-5.438,6.06-8.369.9-2.663,1.312-6.306-.36-8.768a4.989,4.989,0,0,0-7.319-1.251c-3.23,2.711-2.54,10.281-1.125,13.768.092.223,1.463,2.741,2.189,4.011-.818-.885-1.636-1.764-2.473-2.7-1.214-1.337-2.454-2.792-3.665-4.2q-.9-1.122-1.82-2.272c-.634-.759-1.145-1.56-1.734-2.35-.835-1.172-1.636-2.426-2.44-3.677,1.438-1.153,5.6-4.614,6.851-7.032,1.3-2.5,2.253-6.035.974-8.721a4.99,4.99,0,0,0-7.046-2.342c-3.6,2.186-4.07,9.776-3.2,13.436.028.12.293.874.617,1.767-.748-1.242-1.5-2.482-2.214-3.766-2.029-3.646-3.984-7.423-5.957-11.2-.413-.784-.835-1.566-1.251-2.35,1.217-.966,5.756-4.676,7.071-7.208,1.3-2.5,2.253-6.035.971-8.721a4.993,4.993,0,0,0-7.046-2.345c-3.6,2.189-4.067,9.776-3.2,13.439.033.131.352,1.033.715,2.035-1.1-2.035-2.225-4.051-3.4-6.016a88.034,88.034,0,0,0-6.658-9.723c.433-.335,5.843-4.578,7.306-7.392,1.3-2.5,2.25-6.035.971-8.721a4.991,4.991,0,0,0-7.046-2.345c-3.6,2.189-4.067,9.776-3.2,13.439.061.26,1.237,3.509,1.7,4.656-.031-.036-.056-.078-.084-.112a64.979,64.979,0,0,0-8.143-8.216,88.908,88.908,0,0,0-8.246-6.236c-2.644-1.806-5.17-3.3-7.417-4.6-1.223-.7-2.356-1.309-3.417-1.87l.084-.031c.073-.025-3.1-4.048-3.325-4.279-2.655-2.672-9.349-6.273-13.106-4.363a4.987,4.987,0,0,0-1.72,7.222c1.608,2.5,5.12,3.556,7.922,3.769,2.875.221,8.514-1.728,9.907-2.23,1.092.606,2.25,1.265,3.515,2.018,2.217,1.348,4.7,2.886,7.294,4.746.69.491,1.415,1.05,2.127,1.58-1.385-.642-3.3-1.5-3.492-1.56-3.584-1.147-11.186-1.259-13.64,2.166a4.992,4.992,0,0,0,1.8,7.205c2.582,1.48,6.183.793,8.768-.31,2.7-1.15,6.9-5.6,7.8-6.583,1.558,1.195,3.129,2.459,4.69,3.872a64.526,64.526,0,0,1,7.864,8.283c.134.176.254.371.388.547-.631-.435-4.252-2.577-4.522-2.7-3.436-1.535-10.979-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.468,8.752.656,3.1-.935,8.456-5.667,8.657-5.846a88.175,88.175,0,0,1,6.222,9.547c1.4,2.445,2.708,4.98,4,7.534-.829-.547-4.2-2.535-4.458-2.652-3.436-1.535-10.979-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.471,8.752.659,3.029-.913,8.179-5.424,8.612-5.806.586,1.161,1.175,2.317,1.753,3.487,1.89,3.813,3.766,7.643,5.737,11.367.681,1.29,1.4,2.535,2.116,3.788-1.273-.784-3.615-2.163-3.83-2.258-3.436-1.535-10.982-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.471,8.749.659s7.118-4.514,8.344-5.575c1.206,2.074,2.448,4.1,3.766,6.044.586.826,1.131,1.706,1.739,2.465l1.77,2.311c1.265,1.535,2.434,2.967,3.646,4.366.609.712,1.2,1.368,1.8,2.052-1.172-.985-3.051-2.515-3.238-2.635-3.166-2.041-10.477-4.118-13.737-1.443a4.989,4.989,0,0,0-.126,7.423c2.11,2.1,5.765,2.37,8.551,1.976,3.068-.435,8.665-3.97,9.349-4.408,1.477,1.667,2.928,3.274,4.319,4.754,4.38,4.693,8.2,8.433,10.921,11.018S99.4,205.1,99.4,205.1l.014.011.02.017a1.481,1.481,0,0,0,1.9-2.27s-1.605-1.345-4.349-3.841",
    transform: "translate(-0.001 177.392)",
    fill: "#ffdbb3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276283",
    "data-name": "Path 276283",
    d: "M15.091,118.006c0-.006,4.461-5.915,5.153-9.142.589-2.75.578-6.415-1.365-8.668a4.991,4.991,0,0,0-7.414-.4c-2.9,3.062-1.343,10.5.466,13.8.156.285,3.115,4.467,3.16,4.405",
    transform: "translate(17.657 176.163)",
    fill: "#ffdbb3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87874",
    "data-name": "Group 87874",
    transform: "translate(0 239.819)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87873",
    "data-name": "Group 87873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87872",
    "data-name": "Group 87872",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276284",
    "data-name": "Path 276284",
    d: "M54.98,220.985c-.91-3.59-2.138-8.746-3.328-14.991-.349-1.8-.687-3.713-1.013-5.684.8-.187,7.225-1.742,9.67-3.637,2.222-1.725,4.573-4.536,4.536-7.512a4.988,4.988,0,0,0-5.413-5.081c-4.19.477-7.791,7.174-8.534,10.865-.047.234-.293,3.09-.388,4.553-.2-1.192-.391-2.376-.572-3.618-.276-1.787-.508-3.685-.743-5.522q-.13-1.436-.265-2.9c-.109-.983-.095-1.935-.151-2.917-.047-1.44-.025-2.928-.006-4.413,1.837-.168,7.216-.762,9.595-2.085,2.457-1.365,5.206-3.788,5.622-6.736a4.993,4.993,0,0,0-4.584-5.843c-4.212-.162-8.788,5.91-10.078,9.447-.042.114-.237.89-.461,1.812.061-1.449.117-2.895.232-4.363.318-4.159.77-8.386,1.206-12.626.092-.882.17-1.767.257-2.649,1.547-.137,7.378-.726,9.874-2.113,2.457-1.365,5.206-3.788,5.622-6.736a4.991,4.991,0,0,0-4.584-5.843c-4.212-.162-8.788,5.91-10.08,9.447-.045.126-.276,1.052-.528,2.091.207-2.306.38-4.606.483-6.9a88.3,88.3,0,0,0-.19-11.783c.544-.042,7.4-.595,10.17-2.136,2.457-1.368,5.206-3.791,5.622-6.739a4.989,4.989,0,0,0-4.584-5.84c-4.212-.165-8.788,5.91-10.078,9.444-.092.251-.9,3.609-1.156,4.818,0-.045,0-.092-.008-.137a64.94,64.94,0,0,0-2.258-11.345,88.237,88.237,0,0,0-3.439-9.751c-1.206-2.965-2.493-5.6-3.649-7.928-.636-1.253-1.242-2.39-1.817-3.442l.087.02c.075.017-.352-5.086-.413-5.4-.74-3.69-4.338-10.39-8.525-10.87a4.99,4.99,0,0,0-5.418,5.075c-.039,2.976,2.311,5.79,4.531,7.515,2.275,1.767,8.054,3.255,9.494,3.607.575,1.105,1.178,2.292,1.817,3.621,1.1,2.345,2.328,5,3.467,7.981.3.793.6,1.658.9,2.49-.8-1.3-1.923-3.065-2.052-3.224-2.356-2.937-8.634-7.222-12.573-5.72a4.988,4.988,0,0,0-2.471,7c1.337,2.66,4.718,4.076,7.484,4.584,2.884.528,8.838-.868,10.136-1.189.639,1.856,1.253,3.777,1.778,5.818a64.207,64.207,0,0,1,1.988,11.247c.017.218.008.449.022.67-.285-.712-2.124-4.494-2.284-4.746-2.018-3.177-7.788-8.126-11.87-7.065a4.993,4.993,0,0,0-3.224,6.689c1.038,2.789,4.243,4.567,6.937,5.377,3.1.93,10.178-.061,10.446-.1a87.891,87.891,0,0,1-.075,11.4c-.187,2.808-.491,5.647-.824,8.492-.391-.916-2.1-4.433-2.256-4.673-2.018-3.177-7.788-8.126-11.87-7.065a4.991,4.991,0,0,0-3.224,6.689c1.038,2.789,4.243,4.567,6.937,5.377,3.029.91,9.815-.011,10.385-.092-.151,1.293-.3,2.582-.461,3.875-.525,4.224-1.075,8.453-1.485,12.646-.142,1.452-.232,2.886-.324,4.327-.631-1.357-1.823-3.8-1.949-3.995-2.021-3.177-7.791-8.129-11.87-7.065a4.986,4.986,0,0,0-3.224,6.686c1.036,2.792,4.24,4.57,6.934,5.377s8.428.162,10.036-.045c-.14,2.4-.223,4.774-.2,7.118.034,1.011,0,2.043.092,3.012q.1,1.466.2,2.906c.207,1.979.394,3.816.634,5.653.114.93.243,1.8.366,2.705-.433-1.468-1.156-3.783-1.245-3.986-1.513-3.445-6.468-9.212-10.661-8.779a4.989,4.989,0,0,0-4.2,6.122c.6,2.914,3.5,5.156,6.041,6.365,2.8,1.329,9.422,1.468,10.231,1.482.313,2.2.636,4.347.977,6.345,1.066,6.331,2.194,11.563,3.034,15.214s1.41,5.737,1.41,5.737l.006.017.006.025a1.481,1.481,0,1,0,2.839-.843s-.595-2.007-1.507-5.6",
    transform: "translate(46.03 -85.908)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276285",
    "data-name": "Path 276285",
    d: "M33.377,108.141c.006,0,6.982-2.473,9.341-4.782,2.01-1.968,4.023-5.03,3.643-7.984A4.988,4.988,0,0,0,40.4,90.953c-4.106.955-6.915,8.02-7.227,11.769-.025.327.134,5.444.207,5.418",
    transform: "translate(59.423 -77.097)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276286",
    "data-name": "Path 276286",
    d: "M96.988,199.02c-2.739-2.493-6.608-6.116-11.043-10.667-1.284-1.309-2.621-2.719-3.984-4.182.567-.6,5.067-5.438,6.06-8.369.9-2.663,1.312-6.306-.36-8.768a4.989,4.989,0,0,0-7.319-1.251c-3.23,2.711-2.54,10.281-1.125,13.768.092.223,1.463,2.741,2.189,4.011-.818-.885-1.636-1.764-2.473-2.7-1.214-1.337-2.454-2.792-3.665-4.2q-.9-1.122-1.82-2.272c-.634-.759-1.145-1.56-1.734-2.35-.835-1.172-1.636-2.426-2.44-3.677,1.438-1.153,5.6-4.614,6.851-7.032,1.3-2.5,2.253-6.035.974-8.721a4.99,4.99,0,0,0-7.046-2.342c-3.6,2.186-4.07,9.776-3.2,13.436.028.12.293.874.617,1.767-.748-1.242-1.5-2.482-2.214-3.766-2.029-3.646-3.984-7.423-5.957-11.2-.413-.784-.835-1.566-1.251-2.35,1.217-.966,5.756-4.676,7.071-7.208,1.3-2.5,2.253-6.035.971-8.721a4.993,4.993,0,0,0-7.046-2.345c-3.6,2.189-4.067,9.776-3.2,13.439.033.131.352,1.033.715,2.035-1.1-2.035-2.225-4.051-3.4-6.016a88.034,88.034,0,0,0-6.658-9.723c.433-.335,5.843-4.578,7.306-7.392,1.3-2.5,2.25-6.035.971-8.721a4.991,4.991,0,0,0-7.046-2.345c-3.6,2.189-4.067,9.776-3.2,13.439.061.26,1.237,3.509,1.7,4.656-.031-.036-.056-.078-.084-.112a64.979,64.979,0,0,0-8.143-8.216,88.908,88.908,0,0,0-8.246-6.236c-2.644-1.806-5.17-3.3-7.417-4.6-1.223-.7-2.356-1.309-3.417-1.87l.084-.031c.073-.025-3.1-4.048-3.325-4.279-2.655-2.672-9.349-6.273-13.106-4.363a4.987,4.987,0,0,0-1.72,7.222c1.608,2.5,5.12,3.556,7.922,3.769,2.875.221,8.514-1.728,9.907-2.23,1.092.606,2.25,1.265,3.515,2.018,2.217,1.348,4.7,2.886,7.294,4.746.69.491,1.415,1.05,2.127,1.58-1.385-.642-3.3-1.5-3.492-1.56-3.584-1.147-11.186-1.259-13.64,2.166a4.992,4.992,0,0,0,1.8,7.205c2.582,1.48,6.183.793,8.768-.31,2.7-1.15,6.9-5.6,7.8-6.583,1.558,1.195,3.129,2.459,4.69,3.872a64.526,64.526,0,0,1,7.864,8.283c.134.176.254.371.388.547-.631-.435-4.252-2.577-4.522-2.7-3.436-1.535-10.979-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.468,8.752.656,3.1-.935,8.456-5.667,8.657-5.846a88.175,88.175,0,0,1,6.222,9.547c1.4,2.445,2.708,4.98,4,7.534-.829-.547-4.2-2.535-4.458-2.652-3.436-1.535-10.979-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.471,8.752.659,3.029-.913,8.179-5.424,8.612-5.806.586,1.161,1.175,2.317,1.753,3.487,1.89,3.813,3.766,7.643,5.737,11.367.681,1.29,1.4,2.535,2.116,3.788-1.273-.784-3.615-2.163-3.83-2.258-3.436-1.535-10.982-2.482-13.8.656a4.988,4.988,0,0,0,1,7.356c2.4,1.756,6.058,1.471,8.749.659s7.118-4.514,8.344-5.575c1.206,2.074,2.448,4.1,3.766,6.044.586.826,1.131,1.706,1.739,2.465l1.77,2.311c1.265,1.535,2.434,2.967,3.646,4.366.609.712,1.2,1.368,1.8,2.052-1.172-.985-3.051-2.515-3.238-2.635-3.166-2.041-10.477-4.118-13.737-1.443a4.989,4.989,0,0,0-.126,7.423c2.11,2.1,5.765,2.37,8.551,1.976,3.068-.435,8.665-3.97,9.349-4.408,1.477,1.667,2.928,3.274,4.319,4.754,4.38,4.693,8.2,8.433,10.921,11.018S99.4,205.1,99.4,205.1l.014.011.02.017a1.481,1.481,0,0,0,1.9-2.27s-1.605-1.345-4.349-3.841",
    transform: "translate(-0.001 -62.427)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276287",
    "data-name": "Path 276287",
    d: "M15.091,118.006c0-.006,4.461-5.915,5.153-9.142.589-2.75.578-6.415-1.365-8.668a4.991,4.991,0,0,0-7.414-.4c-2.9,3.062-1.343,10.5.466,13.8.156.285,3.115,4.467,3.16,4.405",
    transform: "translate(17.657 -63.656)",
    fill: "#ffdbb3"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87877",
    "data-name": "Group 87877",
    transform: "translate(104.863 160.564)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87876",
    "data-name": "Group 87876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87875",
    "data-name": "Group 87875",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276288",
    "data-name": "Path 276288",
    d: "M61.1,193.544c-.748-3.626-1.75-8.833-2.663-15.122-.268-1.815-.522-3.741-.762-5.723.812-.154,7.294-1.421,9.821-3.21,2.3-1.622,4.771-4.33,4.866-7.3a4.988,4.988,0,0,0-5.187-5.312c-4.2.29-8.1,6.82-9,10.474-.059.235-.43,3.076-.589,4.531-.142-1.2-.285-2.387-.413-3.637-.2-1.8-.343-3.7-.5-5.55q-.067-1.44-.137-2.909c-.067-.988-.008-1.935-.02-2.92.014-1.44.1-2.926.187-4.408,1.84-.089,7.241-.444,9.676-1.661,2.515-1.256,5.371-3.556,5.915-6.482a4.989,4.989,0,0,0-4.321-6.038c-4.2-.349-9.039,5.516-10.485,8.992-.047.112-.276.877-.542,1.789.128-1.446.248-2.889.424-4.349.5-4.14,1.142-8.344,1.764-12.559.131-.879.246-1.759.374-2.638,1.549-.067,7.4-.4,9.955-1.672,2.515-1.259,5.371-3.559,5.913-6.485a4.988,4.988,0,0,0-4.319-6.038c-4.2-.346-9.039,5.516-10.488,8.992-.05.126-.324,1.041-.617,2.069.3-2.295.581-4.587.784-6.87a88.547,88.547,0,0,0,.329-11.778c.547-.02,7.417-.271,10.253-1.686,2.515-1.259,5.371-3.559,5.915-6.485a4.99,4.99,0,0,0-4.321-6.038c-4.2-.346-9.039,5.516-10.485,8.992-.1.248-1.064,3.568-1.365,4.762,0-.045,0-.092,0-.137A65.26,65.26,0,0,0,59.3,95.7,88.877,88.877,0,0,0,56.3,85.809c-1.075-3.018-2.242-5.709-3.3-8.082-.581-1.281-1.133-2.443-1.664-3.52l.087.025c.075.02-.126-5.1-.176-5.418-.575-3.721-3.872-10.572-8.034-11.236a4.991,4.991,0,0,0-5.639,4.832c-.17,2.97,2.055,5.885,4.2,7.707,2.194,1.865,7.9,3.607,9.324,4.02.528,1.131,1.078,2.345,1.658,3.7,1,2.392,2.1,5.1,3.11,8.126.268.8.528,1.681.793,2.526-.743-1.332-1.787-3.146-1.909-3.311-2.225-3.037-8.308-7.6-12.308-6.27A4.991,4.991,0,0,0,39.658,85.8c1.22,2.716,4.534,4.277,7.275,4.908,2.859.656,8.869-.477,10.181-.74.556,1.882,1.086,3.83,1.519,5.89a64.416,64.416,0,0,1,1.491,11.323c.006.221-.014.449-.008.67-.251-.723-1.923-4.584-2.071-4.841-1.876-3.261-7.423-8.461-11.546-7.582a4.988,4.988,0,0,0-3.515,6.541c.91,2.833,4.034,4.751,6.691,5.675,3.057,1.069,10.172.388,10.438.363a87.69,87.69,0,0,1-.575,11.381c-.313,2.8-.74,5.619-1.2,8.444-.352-.932-1.907-4.52-2.046-4.765-1.879-3.263-7.426-8.464-11.549-7.582a4.987,4.987,0,0,0-3.515,6.538c.913,2.833,4.037,4.751,6.691,5.678,2.987,1.041,9.8.422,10.379.366-.209,1.284-.41,2.565-.631,3.852-.712,4.193-1.446,8.4-2.043,12.565-.207,1.446-.357,2.875-.514,4.307-.569-1.379-1.653-3.872-1.77-4.076-1.879-3.263-7.426-8.464-11.549-7.582a4.988,4.988,0,0,0-3.515,6.538c.913,2.833,4.037,4.751,6.691,5.678s8.411.533,10.027.4c-.246,2.387-.433,4.76-.508,7.1-.011,1.013-.087,2.043-.042,3.015.025.98.047,1.951.073,2.912.12,1.985.223,3.833.382,5.675.075.935.165,1.815.248,2.719-.368-1.485-.988-3.83-1.069-4.037-1.36-3.509-6.055-9.488-10.265-9.243a4.992,4.992,0,0,0-4.467,5.932c.475,2.937,3.272,5.307,5.756,6.624,2.739,1.452,9.346,1.884,10.153,1.932.215,2.216.447,4.372.7,6.384.784,6.37,1.681,11.646,2.359,15.331s1.156,5.792,1.156,5.792l.006.02.006.025a1.48,1.48,0,0,0,2.873-.717s-.508-2.029-1.259-5.664",
    transform: "translate(-37.565 -57.518)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276289",
    "data-name": "Path 276289",
    d: "M44.721,79.759c.006,0,7.085-2.163,9.542-4.366,2.1-1.876,4.24-4.849,3.992-7.814A4.987,4.987,0,0,0,52.493,62.9c-4.143.773-7.261,7.708-7.738,11.44-.042.324-.106,5.444-.033,5.421",
    transform: "translate(-24.801 -48.026)",
    fill: "#ffdbb3"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276290",
    "data-name": "Path 276290",
    d: "M127.317,155c.145,33.633,26.905,60.784,26.905,60.784s26.525-27.38,26.38-61.012S153.7,93.982,153.7,93.982,127.172,121.364,127.317,155",
    transform: "translate(228.096 168.375)",
    fill: "#fd930d"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_11011",
    "data-name": "Line 11011",
    x1: 0.525,
    y1: 121.799,
    transform: "translate(381.795 262.358)",
    fill: "#fd930d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276291",
    "data-name": "Path 276291",
    d: "M137.118,215.786l-.525-121.8.974-.006.528,121.8Z",
    transform: "translate(244.715 168.374)",
    fill: "#fff"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11012",
    "data-name": "Line 11012",
    x1: 14.974,
    y1: 12.958,
    transform: "translate(367.008 292.694)",
    fill: "#fd930d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276292",
    "data-name": "Path 276292",
    d: "M146.33,118.417l-14.974-12.961.637-.74,14.977,12.958Z",
    transform: "translate(235.333 187.606)",
    fill: "#fff"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11013",
    "data-name": "Line 11013",
    y1: 26.835,
    x2: 18.355,
    transform: "translate(382.305 298.942)",
    fill: "#fd930d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25491",
    "data-name": "Rectangle 25491",
    width: 32.513,
    height: 0.977,
    transform: "matrix(0.563, -0.826, 0.826, 0.563, 381.922, 325.516)",
    fill: "#fff"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11014",
    "data-name": "Line 11014",
    x1: 22.106,
    y1: 19.558,
    transform: "translate(360.012 317.823)",
    fill: "#fd930d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25492",
    "data-name": "Rectangle 25492",
    width: 0.977,
    height: 29.518,
    transform: "matrix(0.663, -0.749, 0.749, 0.663, 359.688, 318.187)",
    fill: "#fff"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11015",
    "data-name": "Line 11015",
    y1: 19.51,
    x2: 21.702,
    transform: "translate(382.423 333.498)",
    fill: "#fd930d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25493",
    "data-name": "Rectangle 25493",
    width: 29.182,
    height: 0.976,
    transform: "matrix(0.743, -0.669, 0.669, 0.743, 382.101, 352.651)",
    fill: "#fff"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11016",
    "data-name": "Line 11016",
    x1: 17.107,
    y1: 13.422,
    transform: "translate(365.374 353.082)",
    fill: "#fd930d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276293",
    "data-name": "Path 276293",
    d: "M147.884,140.536l-17.107-13.425.606-.768,17.107,13.425Z",
    transform: "translate(234.295 226.353)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276294",
    "data-name": "Path 276294",
    d: "M128.515,157.949c13,14.536,35.057,16.018,35.057,16.018s.974-22.081-12.029-36.617-35.056-16.018-35.056-16.018-.974,22.081,12.029,36.617",
    transform: "translate(208.664 217.374)",
    fill: "#fd930d"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11017",
    "data-name": "Line 11017",
    x1: 47.085,
    y1: 52.635,
    transform: "translate(325.15 338.707)",
    fill: "#fd930d"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276295",
    "data-name": "Path 276295",
    d: "M163.431,174.5l-47.085-52.635.731-.65,47.085,52.638Z",
    transform: "translate(208.441 217.166)",
    fill: "#fff"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11018",
    "data-name": "Line 11018",
    x1: 11.482,
    y2: 0.14,
    transform: "translate(330.406 357.416)",
    fill: "#fd930d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25494",
    "data-name": "Rectangle 25494",
    width: 11.48,
    height: 0.976,
    transform: "translate(330.401 357.063) rotate(-0.656)",
    fill: "#fff"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11019",
    "data-name": "Line 11019",
    x1: 2.362,
    y1: 18.703,
    transform: "translate(347.409 347.319)",
    fill: "#fd930d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276296",
    "data-name": "Path 276296",
    d: "M126.637,143.219l-2.362-18.7.971-.12,2.362,18.7Z",
    transform: "translate(222.648 222.863)",
    fill: "#fff"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11020",
    "data-name": "Line 11020",
    x1: 17.112,
    y2: 0.02,
    transform: "translate(337.041 371.128)",
    fill: "#fd930d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25495",
    "data-name": "Rectangle 25495",
    width: 17.115,
    height: 0.976,
    transform: "translate(337.04 370.65)",
    fill: "#fff"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11021",
    "data-name": "Line 11021",
    y1: 16.811,
    x2: 1.909,
    transform: "translate(360.297 360.979)",
    fill: "#fd930d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276297",
    "data-name": "Path 276297",
    d: "M129.863,146.212l-.971-.109L130.8,129.29l.971.112Z",
    transform: "translate(230.918 231.631)",
    fill: "#fff"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11022",
    "data-name": "Line 11022",
    x1: 12.584,
    y2: 0.759,
    transform: "translate(352.93 383.622)",
    fill: "#fd930d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25496",
    "data-name": "Rectangle 25496",
    width: 12.606,
    height: 0.979,
    transform: "translate(352.902 383.891) rotate(-3.434)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276298",
    "data-name": "Path 276298",
    d: "M153.645,136.27c-13.525,14.05-13.358,36.154-13.358,36.154s22.1-.678,35.618-14.728,13.358-36.154,13.358-36.154-22.1.678-35.618,14.728",
    transform: "translate(251.333 217.75)",
    fill: "#fd930d"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11023",
    "data-name": "Line 11023",
    y1: 50.882,
    x2: 48.975,
    transform: "translate(391.621 339.293)",
    fill: "#fd930d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276299",
    "data-name": "Path 276299",
    d: "M140.864,172.978l-.7-.676,48.975-50.882.7.676Z",
    transform: "translate(251.107 217.533)",
    fill: "#fff"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11024",
    "data-name": "Line 11024",
    x1: 0.997,
    y1: 11.44,
    transform: "translate(422.19 345.939)",
    fill: "#fd930d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276300",
    "data-name": "Path 276300",
    d: "M152.057,135.432l-.994-11.437.974-.087,1,11.437Z",
    transform: "translate(270.64 221.99)",
    fill: "#fff"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11025",
    "data-name": "Line 11025",
    y1: 3.752,
    x2: 18.475,
    transform: "translate(415.193 362.13)",
    fill: "#fd930d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25497",
    "data-name": "Rectangle 25497",
    width: 18.851,
    height: 0.98,
    transform: "translate(415.096 365.405) rotate(-11.503)",
    fill: "#fff"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11026",
    "data-name": "Line 11026",
    x1: 1.298,
    y1: 17.065,
    transform: "translate(409.131 353.569)",
    fill: "#fd930d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276301",
    "data-name": "Path 276301",
    d: "M147.683,143.785l-1.3-17.065.977-.078,1.3,17.068Z",
    transform: "translate(262.259 226.888)",
    fill: "#fff"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11027",
    "data-name": "Line 11027",
    x2: 16.906,
    y2: 0.648,
    transform: "translate(404.244 377.258)",
    fill: "#fd930d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276302",
    "data-name": "Path 276302",
    d: "M161.71,136.592l-16.909-.648.039-.977,16.909.648Z",
    transform: "translate(259.422 241.802)",
    fill: "#fff"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11028",
    "data-name": "Line 11028",
    x1: 1.695,
    y1: 12.492,
    transform: "translate(397.123 370.404)",
    fill: "#fd930d"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25498",
    "data-name": "Rectangle 25498",
    width: 0.979,
    height: 12.608,
    transform: "matrix(0.991, -0.134, 0.134, 0.991, 396.637, 370.469)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87880",
    "data-name": "Group 87880",
    transform: "translate(325.136 262.359)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87879",
    "data-name": "Group 87879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87878",
    "data-name": "Group 87878",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276303",
    "data-name": "Path 276303",
    d: "M127.317,155c.145,33.633,26.905,60.784,26.905,60.784s26.525-27.38,26.38-61.012S153.7,93.982,153.7,93.982,127.172,121.364,127.317,155",
    transform: "translate(-97.04 -93.984)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11029",
    "data-name": "Line 11029",
    x1: 0.525,
    y1: 121.799,
    transform: "translate(56.659 -0.001)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11030",
    "data-name": "Line 11030",
    x1: 14.974,
    y1: 12.958,
    transform: "translate(41.872 30.335)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11031",
    "data-name": "Line 11031",
    y1: 26.835,
    x2: 18.355,
    transform: "translate(57.169 36.583)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11032",
    "data-name": "Line 11032",
    x1: 22.106,
    y1: 19.558,
    transform: "translate(34.876 55.464)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11033",
    "data-name": "Line 11033",
    y1: 19.51,
    x2: 21.702,
    transform: "translate(57.286 71.139)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11034",
    "data-name": "Line 11034",
    x1: 17.107,
    y1: 13.422,
    transform: "translate(40.238 90.723)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276304",
    "data-name": "Path 276304",
    d: "M128.515,157.949c13,14.536,35.057,16.018,35.057,16.018s.974-22.081-12.029-36.617-35.056-16.018-35.056-16.018-.974,22.081,12.029,36.617",
    transform: "translate(-116.473 -44.985)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11035",
    "data-name": "Line 11035",
    x1: 47.085,
    y1: 52.635,
    transform: "translate(0.014 76.348)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11036",
    "data-name": "Line 11036",
    x1: 11.482,
    y2: 0.14,
    transform: "translate(5.27 95.057)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11037",
    "data-name": "Line 11037",
    x1: 2.362,
    y1: 18.703,
    transform: "translate(22.273 84.96)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11038",
    "data-name": "Line 11038",
    x1: 17.112,
    y2: 0.02,
    transform: "translate(11.905 108.769)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11039",
    "data-name": "Line 11039",
    y1: 16.811,
    x2: 1.909,
    transform: "translate(35.161 98.62)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11040",
    "data-name": "Line 11040",
    x1: 12.584,
    y2: 0.759,
    transform: "translate(27.794 121.263)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276305",
    "data-name": "Path 276305",
    d: "M153.645,136.27c-13.525,14.05-13.358,36.154-13.358,36.154s22.1-.678,35.618-14.728,13.358-36.154,13.358-36.154-22.1.678-35.618,14.728",
    transform: "translate(-73.803 -44.609)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11041",
    "data-name": "Line 11041",
    y1: 50.882,
    x2: 48.975,
    transform: "translate(66.484 76.934)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11042",
    "data-name": "Line 11042",
    x1: 0.997,
    y1: 11.44,
    transform: "translate(97.054 83.58)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11043",
    "data-name": "Line 11043",
    y1: 3.752,
    x2: 18.475,
    transform: "translate(90.057 99.771)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11044",
    "data-name": "Line 11044",
    x1: 1.298,
    y1: 17.065,
    transform: "translate(83.994 91.21)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11045",
    "data-name": "Line 11045",
    x2: 16.906,
    y2: 0.648,
    transform: "translate(79.108 114.899)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11046",
    "data-name": "Line 11046",
    x1: 1.695,
    y1: 12.492,
    transform: "translate(71.986 108.045)",
    fill: "#ffdbb3"
  }))))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25500",
    "data-name": "Rectangle 25500",
    width: 264.797,
    height: 340.828,
    transform: "translate(98.235 48.724)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276306",
    "data-name": "Path 276306",
    d: "M300.328,359.151H35.529a.53.53,0,0,1-.528-.53V17.793a.529.529,0,0,1,.528-.528h264.8a.529.529,0,0,1,.528.528V358.62a.53.53,0,0,1-.528.53M36.059,358.093H299.8V18.323H36.059Z",
    transform: "translate(62.707 30.931)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87883",
    "data-name": "Group 87883",
    transform: "translate(98.236 48.724)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87882",
    "data-name": "Group 87882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87881",
    "data-name": "Group 87881",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25501",
    "data-name": "Rectangle 25501",
    width: 42.239,
    height: 340.828,
    transform: "translate(0.002 0)",
    fill: "#fd930d"
  }))))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25503",
    "data-name": "Rectangle 25503",
    width: 81.204,
    height: 9.553,
    transform: "translate(222.996 99.075)",
    fill: "#fd930d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276307",
    "data-name": "Path 276307",
    d: "M161.424,45.913h-81.2a.53.53,0,0,1-.528-.53V35.83a.529.529,0,0,1,.528-.528h81.2a.53.53,0,0,1,.53.528v9.553a.53.53,0,0,1-.53.53M80.751,44.855H160.9V36.36H80.751Z",
    transform: "translate(142.775 63.246)",
    fill: "#515255"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25504",
    "data-name": "Rectangle 25504",
    width: 222.602,
    height: 9.553,
    transform: "translate(131.561 180.477)",
    fill: "#ffdbb3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25505",
    "data-name": "Rectangle 25505",
    width: 222.602,
    height: 9.553,
    transform: "translate(131.561 311.779)",
    fill: "#ffdbb3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25506",
    "data-name": "Rectangle 25506",
    width: 51.181,
    height: 9.553,
    transform: "translate(222.999 115.529)",
    fill: "#fd930d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276308",
    "data-name": "Path 276308",
    d: "M131.4,51.806H80.221a.529.529,0,0,1-.528-.528V41.725a.53.53,0,0,1,.528-.53H131.4a.53.53,0,0,1,.53.53v9.553a.53.53,0,0,1-.53.528m-50.65-1.058h50.123V42.253H80.751Z",
    transform: "translate(142.775 73.804)",
    fill: "#515255"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25507",
    "data-name": "Rectangle 25507",
    width: 51.181,
    height: 9.553,
    transform: "translate(222.999 131.645)",
    fill: "#fd930d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276309",
    "data-name": "Path 276309",
    d: "M131.4,57.58H80.221a.53.53,0,0,1-.528-.53V47.5a.529.529,0,0,1,.528-.528H131.4a.53.53,0,0,1,.53.528v9.553a.53.53,0,0,1-.53.53m-50.65-1.058h50.123V48.027H80.751Z",
    transform: "translate(142.775 84.148)",
    fill: "#515255"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25508",
    "data-name": "Rectangle 25508",
    width: 5.265,
    height: 5.265,
    transform: "translate(210.685 200.546)",
    fill: "#fd930d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276310",
    "data-name": "Path 276310",
    d: "M81.077,77.971H75.81a.529.529,0,0,1-.528-.528V72.179a.529.529,0,0,1,.528-.528h5.268a.53.53,0,0,1,.53.528v5.265a.53.53,0,0,1-.53.528M76.34,76.913h4.21V72.706H76.34Z",
    transform: "translate(134.873 128.367)",
    fill: "#515255"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25509",
    "data-name": "Rectangle 25509",
    width: 5.265,
    height: 5.265,
    transform: "translate(210.685 268.339)",
    fill: "#fd930d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276311",
    "data-name": "Path 276311",
    d: "M81.077,102.256H75.81a.529.529,0,0,1-.528-.528V96.464a.529.529,0,0,1,.528-.528h5.268a.53.53,0,0,1,.53.528v5.265a.53.53,0,0,1-.53.528M76.34,101.2h4.21V96.991H76.34Z",
    transform: "translate(134.873 171.876)",
    fill: "#515255"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25510",
    "data-name": "Rectangle 25510",
    width: 5.265,
    height: 5.265,
    transform: "translate(285.061 200.546)",
    fill: "#fd930d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276312",
    "data-name": "Path 276312",
    d: "M107.72,77.971h-5.265a.53.53,0,0,1-.53-.528V72.179a.53.53,0,0,1,.53-.528h5.265a.529.529,0,0,1,.528.528v5.265a.529.529,0,0,1-.528.528m-4.737-1.058h4.207V72.706h-4.207Z",
    transform: "translate(182.605 128.367)",
    fill: "#515255"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25511",
    "data-name": "Rectangle 25511",
    width: 5.265,
    height: 5.265,
    transform: "translate(285.061 268.339)",
    fill: "#fd930d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276313",
    "data-name": "Path 276313",
    d: "M107.72,102.256h-5.265a.53.53,0,0,1-.53-.528V96.464a.53.53,0,0,1,.53-.528h5.265a.529.529,0,0,1,.528.528v5.265a.529.529,0,0,1-.528.528m-4.737-1.058h4.207V96.991h-4.207Z",
    transform: "translate(182.605 171.876)",
    fill: "#515255"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25512",
    "data-name": "Rectangle 25512",
    width: 264.797,
    height: 17.336,
    transform: "translate(98.235 48.724)",
    fill: "#515255"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276314",
    "data-name": "Path 276314",
    d: "M300.328,35.659H35.529a.53.53,0,0,1-.528-.53V17.793a.529.529,0,0,1,.528-.528h264.8a.529.529,0,0,1,.528.528V35.128a.53.53,0,0,1-.528.53M36.059,34.6H299.8V18.323H36.059Z",
    transform: "translate(62.707 30.931)",
    fill: "#515255"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276315",
    "data-name": "Path 276315",
    d: "M127.993,75.084H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 129.131)",
    fill: "#515255"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276316",
    "data-name": "Path 276316",
    d: "M127.993,77.776H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 133.954)",
    fill: "#515255"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276317",
    "data-name": "Path 276317",
    d: "M127.993,80.469H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 138.778)",
    fill: "#515255"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276318",
    "data-name": "Path 276318",
    d: "M127.993,83.162H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 143.603)",
    fill: "#515255"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276319",
    "data-name": "Path 276319",
    d: "M127.993,85.855H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 148.428)",
    fill: "#515255"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276320",
    "data-name": "Path 276320",
    d: "M153.249,75.084H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 129.131)",
    fill: "#515255"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276321",
    "data-name": "Path 276321",
    d: "M153.249,77.776H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 133.954)",
    fill: "#515255"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276322",
    "data-name": "Path 276322",
    d: "M153.249,80.469H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 138.778)",
    fill: "#515255"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276323",
    "data-name": "Path 276323",
    d: "M153.249,83.162H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 143.603)",
    fill: "#515255"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276324",
    "data-name": "Path 276324",
    d: "M153.249,85.855H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 148.428)",
    fill: "#515255"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276325",
    "data-name": "Path 276325",
    d: "M127.993,98.96H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 171.906)",
    fill: "#515255"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276326",
    "data-name": "Path 276326",
    d: "M127.993,101.653H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 176.731)",
    fill: "#515255"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276327",
    "data-name": "Path 276327",
    d: "M127.993,104.345H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 181.555)",
    fill: "#515255"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276328",
    "data-name": "Path 276328",
    d: "M127.993,107.038H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 186.378)",
    fill: "#515255"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276329",
    "data-name": "Path 276329",
    d: "M127.993,109.731H81.385a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(143.116 191.203)",
    fill: "#515255"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276330",
    "data-name": "Path 276330",
    d: "M153.249,98.96H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 171.906)",
    fill: "#515255"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276331",
    "data-name": "Path 276331",
    d: "M153.249,101.653H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 176.731)",
    fill: "#515255"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276332",
    "data-name": "Path 276332",
    d: "M153.249,104.345H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 181.555)",
    fill: "#515255"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276333",
    "data-name": "Path 276333",
    d: "M153.249,107.038H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 186.378)",
    fill: "#515255"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276334",
    "data-name": "Path 276334",
    d: "M153.249,109.731H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 191.203)",
    fill: "#515255"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276335",
    "data-name": "Path 276335",
    d: "M153.249,122.023H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 213.225)",
    fill: "#515255"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276336",
    "data-name": "Path 276336",
    d: "M153.249,124.715H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 218.048)",
    fill: "#515255"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276337",
    "data-name": "Path 276337",
    d: "M153.249,127.408H106.641a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.363 222.873)",
    fill: "#515255"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276338",
    "data-name": "Path 276338",
    d: "M153.248,130.1H106.64a1.5,1.5,0,0,1,0-3.007h46.608a1.5,1.5,0,1,1,0,3.007",
    transform: "translate(188.362 227.697)",
    fill: "#515255"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276339",
    "data-name": "Path 276339",
    d: "M153.249,132.793H106.641a1.5,1.5,0,0,1,0-3.006h46.608a1.5,1.5,0,1,1,0,3.006",
    transform: "translate(188.363 232.522)",
    fill: "#515255"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276340",
    "data-name": "Path 276340",
    d: "M197.947,88.772a6.011,6.011,0,0,0-5.924,5.011h-7.2a6.007,6.007,0,0,0-11.847,0h-7.2a6.007,6.007,0,0,0-11.847,0h-7.2a6.005,6.005,0,0,0-11.845,0h-7.2a6.007,6.007,0,0,0-11.847,0h-7.2a6.007,6.007,0,0,0-11.847,0h-7.2a6.016,6.016,0,1,0,0,2h7.2a6.006,6.006,0,0,0,11.847,0h7.2a6.006,6.006,0,0,0,11.847,0h7.2a6,6,0,0,0,11.845,0h7.2a6.006,6.006,0,0,0,11.847,0h7.2a6.006,6.006,0,0,0,11.847,0h7.2a6.011,6.011,0,1,0,5.924-7.015",
    transform: "translate(139.154 159.041)",
    fill: "#515255"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276341",
    "data-name": "Path 276341",
    d: "M77.031,119.215a10.129,10.129,0,1,0,10.128,10.131,10.13,10.13,0,0,0-10.128-10.131m0,15.181a5.051,5.051,0,1,1,5.05-5.05,5.053,5.053,0,0,1-5.05,5.05",
    transform: "translate(119.856 213.581)",
    fill: "#fd930d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276342",
    "data-name": "Path 276342",
    d: "M77.369,140.34a10.657,10.657,0,1,1,10.655-10.658A10.669,10.669,0,0,1,77.369,140.34m0-20.256a9.6,9.6,0,1,0,9.6,9.6,9.611,9.611,0,0,0-9.6-9.6m0,15.178a5.579,5.579,0,1,1,5.578-5.58,5.584,5.584,0,0,1-5.578,5.58m0-10.1a4.521,4.521,0,1,0,4.52,4.52,4.526,4.526,0,0,0-4.52-4.52",
    transform: "translate(119.517 213.243)",
    fill: "#515255"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276343",
    "data-name": "Path 276343",
    d: "M73.513,133.372l4.849,2.345a10.121,10.121,0,0,0-7.816-16.5V124.3a5.033,5.033,0,0,1,2.967,9.075",
    transform: "translate(126.388 213.583)",
    fill: "#515255"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276344",
    "data-name": "Path 276344",
    d: "M78.706,136.585a.571.571,0,0,1-.234-.05l-4.849-2.345a.543.543,0,0,1-.3-.427.532.532,0,0,1,.209-.475,4.479,4.479,0,0,0,1.823-3.607,4.535,4.535,0,0,0-4.478-4.52.527.527,0,0,1-.525-.528v-5.078a.529.529,0,0,1,.53-.53h0a10.653,10.653,0,0,1,8.227,17.366.532.532,0,0,1-.41.193m-3.9-3,3.741,1.806A9.588,9.588,0,0,0,71.414,120.1v4.031a5.6,5.6,0,0,1,5,5.547,5.51,5.51,0,0,1-1.608,3.9",
    transform: "translate(126.047 213.243)",
    fill: "#515255"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276345",
    "data-name": "Path 276345",
    d: "M80.023,134.079H70.367a2.415,2.415,0,0,1,0-4.829h9.656a2.415,2.415,0,0,1,0,4.829",
    transform: "translate(121.74 231.56)",
    fill: "#fd930d"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276346",
    "data-name": "Path 276346",
    d: "M80.363,134.946H70.7a2.942,2.942,0,1,1,0-5.885h9.659a2.942,2.942,0,1,1,0,5.885M70.7,130.119a1.886,1.886,0,0,0,0,3.771h9.659a1.886,1.886,0,0,0,0-3.771Z",
    transform: "translate(121.4 231.221)",
    fill: "#515255"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276347",
    "data-name": "Path 276347",
    d: "M87.848,119.215a10.129,10.129,0,1,0,10.128,10.131,10.129,10.129,0,0,0-10.128-10.131m0,15.181a5.051,5.051,0,1,1,5.05-5.05,5.05,5.05,0,0,1-5.05,5.05",
    transform: "translate(139.24 213.581)",
    fill: "#fd930d"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276348",
    "data-name": "Path 276348",
    d: "M88.188,140.34a10.657,10.657,0,1,1,10.655-10.658A10.669,10.669,0,0,1,88.188,140.34m0-20.256a9.6,9.6,0,1,0,9.6,9.6,9.611,9.611,0,0,0-9.6-9.6m0,15.178a5.579,5.579,0,1,1,5.578-5.58,5.584,5.584,0,0,1-5.578,5.58m0-10.1a4.521,4.521,0,1,0,4.52,4.52,4.526,4.526,0,0,0-4.52-4.52",
    transform: "translate(138.9 213.243)",
    fill: "#515255"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276349",
    "data-name": "Path 276349",
    d: "M91.39,128.283a10.127,10.127,0,0,0-10.025-9.067V124.3a4.86,4.86,0,0,1,4.944,5.633Z",
    transform: "translate(145.771 213.583)",
    fill: "#515255"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276350",
    "data-name": "Path 276350",
    d: "M86.647,130.8a.544.544,0,0,1-.335-.117.528.528,0,0,1-.19-.472l.02-.167a3.127,3.127,0,0,0,.034-.363,4.536,4.536,0,0,0-4.475-4.517.527.527,0,0,1-.525-.528v-5.081a.528.528,0,0,1,.156-.374.521.521,0,0,1,.374-.154h0a10.623,10.623,0,0,1,10.544,9.542.526.526,0,0,1-.363.558l-5.078,1.647a.562.562,0,0,1-.165.025m-4.413-6.663a5.6,5.6,0,0,1,5,5.388l3.911-1.267a9.564,9.564,0,0,0-8.911-8.151Z",
    transform: "translate(145.432 213.245)",
    fill: "#515255"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276351",
    "data-name": "Path 276351",
    d: "M90.825,134.079H81.169a2.415,2.415,0,1,1,0-4.829h9.656a2.415,2.415,0,1,1,0,4.829",
    transform: "translate(141.093 231.56)",
    fill: "#fd930d"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276352",
    "data-name": "Path 276352",
    d: "M91.165,134.946H81.506a2.942,2.942,0,1,1,0-5.885h9.659a2.942,2.942,0,1,1,0,5.885m-9.659-4.827a1.886,1.886,0,0,0,0,3.771h9.659a1.886,1.886,0,0,0,0-3.771Z",
    transform: "translate(140.753 231.221)",
    fill: "#515255"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276353",
    "data-name": "Path 276353",
    d: "M98.731,119.215a10.129,10.129,0,1,0,10.128,10.131,10.129,10.129,0,0,0-10.128-10.131m0,15.181a5.051,5.051,0,1,1,5.05-5.05,5.05,5.05,0,0,1-5.05,5.05",
    transform: "translate(158.738 213.581)",
    fill: "#fd930d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276354",
    "data-name": "Path 276354",
    d: "M99.071,140.34a10.657,10.657,0,1,1,10.655-10.658A10.669,10.669,0,0,1,99.071,140.34m0-20.256a9.6,9.6,0,1,0,9.6,9.6,9.611,9.611,0,0,0-9.6-9.6m0,15.178a5.579,5.579,0,1,1,5.578-5.58,5.584,5.584,0,0,1-5.578,5.58m0-10.1a4.521,4.521,0,1,0,4.52,4.52,4.526,4.526,0,0,0-4.52-4.52",
    transform: "translate(158.398 213.243)",
    fill: "#515255"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276355",
    "data-name": "Path 276355",
    d: "M97.327,119.216V124.3a5.049,5.049,0,1,1-3.9,8.277l-4.014,3.143a10.126,10.126,0,1,0,7.914-16.5",
    transform: "translate(160.189 213.583)",
    fill: "#515255"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276356",
    "data-name": "Path 276356",
    d: "M97.621,140.34a10.632,10.632,0,0,1-8.28-3.947.535.535,0,0,1-.114-.4.526.526,0,0,1,.2-.357l4.017-3.143a.533.533,0,0,1,.734.078,4.511,4.511,0,1,0,3.487-7.412.527.527,0,0,1-.525-.528v-5.078a.529.529,0,0,1,.53-.53h0a10.657,10.657,0,0,1-.05,21.314m-7.1-4.207A9.6,9.6,0,1,0,98.2,120.1v4.031a5.578,5.578,0,0,1-.575,11.127,5.531,5.531,0,0,1-3.911-1.63Z",
    transform: "translate(159.848 213.243)",
    fill: "#515255"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276357",
    "data-name": "Path 276357",
    d: "M101.707,134.079H92.051a2.415,2.415,0,0,1,0-4.829h9.656a2.415,2.415,0,1,1,0,4.829",
    transform: "translate(160.589 231.56)",
    fill: "#fd930d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276358",
    "data-name": "Path 276358",
    d: "M102.048,134.946H92.389a2.942,2.942,0,1,1,0-5.885h9.659a2.942,2.942,0,1,1,0,5.885m-9.659-4.827a1.886,1.886,0,0,0,0,3.771h9.659a1.886,1.886,0,0,0,0-3.771Z",
    transform: "translate(160.25 231.221)",
    fill: "#515255"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276359",
    "data-name": "Path 276359",
    d: "M129.4,76.123A45.341,45.341,0,1,1,84.061,30.782,45.341,45.341,0,0,1,129.4,76.123",
    transform: "translate(69.369 55.148)",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276360",
    "data-name": "Path 276360",
    d: "M67.749,138.965s6.549,9.843,5.642,13.737-6.652,2.7-9.374-1.5-9.611-10.471-8.4-13.168,9.715-1.468,12.135.927",
    transform: "translate(99.384 244.566)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276361",
    "data-name": "Path 276361",
    d: "M70.638,155.975a8.728,8.728,0,0,1-6.73-4.112,50.7,50.7,0,0,0-3.484-4.466c-3.043-3.643-5.918-7.085-4.958-9.226a3.438,3.438,0,0,1,2.713-1.694c3.341-.631,8.433.6,10.309,2.457.022.028.047.053.07.084.274.413,6.669,10.089,5.72,14.167a3.388,3.388,0,0,1-2.839,2.725,4.456,4.456,0,0,1-.8.067M60.069,137.414a9.113,9.113,0,0,0-1.686.142c-.715.131-1.627.424-1.915,1.064-.678,1.516,2.359,5.15,4.8,8.07a51.754,51.754,0,0,1,3.559,4.573c1.711,2.638,4.634,3.883,6.423,3.562a2.314,2.314,0,0,0,1.957-1.89c.692-2.984-3.73-10.535-5.533-13.26-1.354-1.3-4.807-2.261-7.607-2.261",
    transform: "translate(99.033 244.207)",
    fill: "#515255"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276362",
    "data-name": "Path 276362",
    d: "M54.162,137.765s-7.911,11.744-6.652,14.954,5.351,2.247,8.5-.642,9.4-11.041,9.4-11.041-5.265-6.482-11.247-3.272",
    transform: "translate(84.874 245.216)",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276363",
    "data-name": "Path 276363",
    d: "M50.8,155.619a4.257,4.257,0,0,1-.955-.1,3.477,3.477,0,0,1-2.5-2.25c-1.326-3.381,5.882-14.234,6.708-15.462a.529.529,0,0,1,.2-.173c6.309-3.383,11.881,3.341,11.934,3.406a.553.553,0,0,1,.011.684c-.257.332-6.315,8.221-9.463,11.108a9.4,9.4,0,0,1-5.926,2.792m4.084-17.084c-3,4.466-7.353,12.207-6.521,14.329a2.391,2.391,0,0,0,1.731,1.58c1.549.371,3.886-.586,5.893-2.423,2.7-2.485,7.816-9.017,9.056-10.616-1.128-1.231-5.377-5.335-10.159-2.87",
    transform: "translate(84.528 244.87)",
    fill: "#515255"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276364",
    "data-name": "Path 276364",
    d: "M48.869,150.565a5.939,5.939,0,0,1-1.279-.114.413.413,0,0,1-.3-.5.405.405,0,0,1,.494-.3,9.442,9.442,0,0,0,5.929-1.178c3.475-1.77,9.692-9.863,9.757-9.944a.405.405,0,0,1,.578-.078.413.413,0,0,1,.075.578c-.26.338-6.393,8.324-10.033,10.181a11.545,11.545,0,0,1-5.217,1.357",
    transform: "translate(84.696 247.886)",
    fill: "#515255"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276365",
    "data-name": "Path 276365",
    d: "M69.639,152.219c-1.708,0-3.5-1.354-6.063-3.8-3.864-3.674-7.211-9.938-7.35-10.2a.411.411,0,0,1,.726-.385c.036.064,3.431,6.412,7.191,9.994,4.053,3.855,5.572,4.358,7.73,2.582a.412.412,0,1,1,.522.636,4.325,4.325,0,0,1-2.755,1.175",
    transform: "translate(100.644 246.542)",
    fill: "#515255"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276366",
    "data-name": "Path 276366",
    d: "M50.077,84.7s-6.926,14.122-6.613,19.9,1.574,34.99,3.464,44.618,3.78,33.619,5.039,43.247S61.5,224.5,61.5,224.5s-1.259,5.137-.315,6.742,10.932,4.235,11.247,3.272,1.89-3.852,2.205-6.742-4.408-33.705-2.521-40.444,2.261-52.063,2.521-56.73c.251-4.52-.078-12.9-.078-12.9a2.934,2.934,0,0,0,3.149-.963c1.259-1.6,5.43,42.027,6.689,52.3s-1.574,13.162-2.518,19.583-3.149,27.282-3.149,29.85-2.833,10.915-1.574,12.52,3.928,1.343,5.025,1.647c3.286.913,5.846-.516,7.1-.837s2.32-4.977,2.32-4.977,10.111-28.574,12-40.45,5.036-33.94,4.408-47.42-4.408-40.768-4.408-40.768l-.946-8.023Z",
    transform: "translate(77.849 151.738)",
    fill: "#515255"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276367",
    "data-name": "Path 276367",
    d: "M72.116,235.62c-2.4,0-10.052-2.055-11.052-3.746-.958-1.63-.02-5.971.218-6.987-.8-2.172-8.3-22.734-9.511-32-.455-3.478-1-8.913-1.577-14.67-1.055-10.5-2.25-22.408-3.453-28.544-1.669-8.512-2.825-31.754-3.319-41.675l-.154-3.018c-.321-5.854,6.382-19.591,6.666-20.175a.541.541,0,0,1,.55-.3l52.585,5.458a.546.546,0,0,1,.489.48l.944,8.023c.036.262,3.785,27.455,4.411,40.807.592,12.635-2.074,32.823-4.413,47.532-1.876,11.789-11.926,40.26-12.026,40.547-.248,1.105-1.231,4.947-2.7,5.323-.237.059-.522.162-.851.279a10.414,10.414,0,0,1-6.538.556,7.564,7.564,0,0,0-1.055-.151c-1.343-.137-3.182-.321-4.252-1.689-.888-1.122-.321-4.028.645-8.333a28.334,28.334,0,0,0,.812-4.522c0-2.549,2.211-23.53,3.154-29.931a38.392,38.392,0,0,1,1.3-5.488A29.555,29.555,0,0,0,84.2,169.449c-.318-2.6-.826-7.381-1.418-12.917-1.407-13.2-3.707-34.747-4.8-38.579a3.422,3.422,0,0,1-2.5.759c.073,2.1.262,8.525.053,12.269-.061,1.089-.126,4.394-.218,8.975-.3,14.9-.857,42.647-2.32,47.87-1.239,4.416.483,19.9,1.622,30.143a98.939,98.939,0,0,1,.913,10.214,20.9,20.9,0,0,1-1.806,5.837c-.193.438-.346.784-.419,1.016a.926.926,0,0,1-.882.569c-.092.008-.2.014-.31.014M50.755,85.634c-1.047,2.189-6.669,14.209-6.39,19.284l.154,3.023c.449,9.047,1.644,33.086,3.3,41.519,1.214,6.186,2.412,18.117,3.467,28.644.578,5.751,1.125,11.177,1.577,14.639,1.234,9.458,9.424,31.7,9.505,31.919a.549.549,0,0,1,.02.321c-.466,1.9-.983,5.3-.377,6.334.715,1.209,8.8,3.515,10.318,3.2.089-.24.226-.556.388-.932a19.687,19.687,0,0,0,1.725-5.522c.1-.891-.368-5.1-.913-9.974-1.217-10.946-2.884-25.936-1.588-30.557,1.426-5.092,1.982-32.745,2.278-47.6.092-4.589.159-7.909.221-9.011.248-4.447-.073-12.769-.075-12.852a.548.548,0,0,1,.726-.542,2.379,2.379,0,0,0,2.54-.779.7.7,0,0,1,.67-.232c.949.271,1.761,4.129,5.578,39.9.589,5.533,1.1,10.309,1.418,12.9A30.808,30.808,0,0,1,84.042,183.7a38.357,38.357,0,0,0-1.267,5.34c-.941,6.379-3.143,27.248-3.143,29.772a28,28,0,0,1-.837,4.762c-.592,2.635-1.482,6.616-.857,7.417.784,1,2.295,1.147,3.5,1.27a8.2,8.2,0,0,1,1.239.187,9.2,9.2,0,0,0,5.871-.53c.368-.131.684-.243.949-.31.5-.128,1.4-2.261,1.921-4.567.117-.346,10.133-28.725,11.993-40.413,2.331-14.659,4.989-34.763,4.4-47.311-.62-13.3-4.366-40.441-4.405-40.715l-.891-7.6Z",
    transform: "translate(77.498 151.386)",
    fill: "#515255"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276368",
    "data-name": "Path 276368",
    d: "M49,104.094a.282.282,0,0,1-.193-.078C43.6,98.807,44.149,90.784,44.157,90.7a.271.271,0,0,1,.268-.251l.022,0a.268.268,0,0,1,.248.293c-.006.075-.533,7.855,4.492,12.88a.272.272,0,0,1-.193.466",
    transform: "translate(79.074 162.051)",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276369",
    "data-name": "Path 276369",
    d: "M51.225,100.822l-.045-.006c-3.738-.625-6.761-5.7-6.89-5.915a.272.272,0,0,1,.095-.374.277.277,0,0,1,.374.095c.028.053,3.023,5.078,6.51,5.661a.269.269,0,0,1,.223.31.272.272,0,0,1-.268.229",
    transform: "translate(79.281 169.284)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276370",
    "data-name": "Path 276370",
    d: "M57.936,154.967l-.039,0c-.187-.028-4.642-.639-6.194-1.588-.234-.145-.338-.315-.31-.505.064-.385.625-.516,1.742-.77,1.407-.324,3.534-.81,4.159-1.915a1.563,1.563,0,0,0,.075-1.309c-.48-1.468-1.669-1.94-2.928-2.44-1.742-.692-3.545-1.407-3.174-4.815.606-5.564,4.852-15.809,4.894-15.912a.282.282,0,0,1,.36-.148.277.277,0,0,1,.148.36c-.045.1-4.257,10.273-4.855,15.758-.329,2.993,1.136,3.576,2.831,4.249,1.259.5,2.688,1.066,3.247,2.78a2.1,2.1,0,0,1-.12,1.747c-.743,1.315-2.92,1.815-4.514,2.18a11.163,11.163,0,0,0-1.195.313c1.521.865,5.865,1.466,5.913,1.471a.275.275,0,0,1-.039.547",
    transform: "translate(91.759 224.917)",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276371",
    "data-name": "Path 276371",
    d: "M56.2,182.328a.275.275,0,0,1-.26-.187.272.272,0,0,1,.173-.346c.1-.036.313-.092.609-.165,6.831-1.689,9.946-4.14,9.262-7.28a9.992,9.992,0,0,0-3.3-5.106c-1.784-1.764-3.632-3.593-3.1-7.414.483-3.431,3.2-8.81,5.837-14.008,2.323-4.589,4.517-8.922,4.517-10.8,0-1.667-1.217-5.393-2.627-9.709-1.929-5.91-4.33-13.263-4.681-18.662a.27.27,0,0,1,.254-.29l.017,0a.273.273,0,0,1,.274.257c.352,5.332,2.739,12.649,4.659,18.525,1.482,4.542,2.655,8.129,2.655,9.882,0,2-2.122,6.192-4.575,11.043-2.493,4.916-5.318,10.493-5.784,13.838-.5,3.548,1.172,5.2,2.942,6.945,1.429,1.413,2.9,2.87,3.448,5.382.762,3.484-2.487,6.153-9.664,7.928-.274.07-.472.117-.567.148a.229.229,0,0,1-.087.017",
    transform: "translate(100.195 194.139)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276372",
    "data-name": "Path 276372",
    d: "M58.669,102.532a.22.22,0,0,1-.148-.059c-.142-.117-.142-.3-.006-.53.91-1.513,7.643-11.18,7.931-11.591a.267.267,0,0,1,.377-.07.274.274,0,0,1,.07.38c-.061.089-5.633,8.084-7.442,10.831,1.574-1.206,5.064-4.263,7.342-6.315a.275.275,0,0,1,.382.02.271.271,0,0,1-.02.385c-6.809,6.128-8.115,6.948-8.486,6.948",
    transform: "translate(104.652 161.659)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276373",
    "data-name": "Path 276373",
    d: "M55.738,106.734a.274.274,0,0,1-.274-.274V98.1c0-1.491-.748-8.763-.757-8.838a.271.271,0,1,1,.539-.053c.033.3.765,7.373.765,8.891v8.358a.274.274,0,0,1-.274.274",
    transform: "translate(98.01 159.386)",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276374",
    "data-name": "Path 276374",
    d: "M55.251,100.871a.272.272,0,0,1-.042-.542c.031,0,3.132-.511,3.83-2.847.74-2.459.5-7.456.5-7.5a.276.276,0,0,1,.26-.288h.014a.271.271,0,0,1,.271.26c.008.209.246,5.142-.516,7.691-.8,2.666-4.132,3.2-4.271,3.227l-.042,0",
    transform: "translate(98.497 160.687)",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276375",
    "data-name": "Path 276375",
    d: "M156.929,72.283c-3.777-11.018-4.408-17-4.723-20.15s-3.777-2.205-3.777-2.205-7.557,4.408-7.557,5.354,3.464,24.245,4.092,28.337a52.8,52.8,0,0,1,.631,7.241s-13.224-14.167-16.688-17.632c-2.646-2.646-4.743-4.916-6.987-6.267-1.212-1.108-3.314-1.471-6.552-2.549-5.67-1.89-11.652-6.3-18.578-5.982A41.008,41.008,0,0,0,83.566,61.58s-10.078,4.721-17,7.869a11.858,11.858,0,0,0-2.289,1.337c-1.139-.148-3.515.463-6.211,6.535-3.78,8.5-20.783,30.858-23.617,38.73s3.149,15.742,9.762,22.039a189.512,189.512,0,0,1,13.539,14.8l7.462-9.254a42.336,42.336,0,0,0,1.038,6.105c.946,3.149,4.092,6.613,16.688,7.557s40.908,2.649,39.989-3.777c-1.3-9.12-.631-38.415-1.259-46.287a134.436,134.436,0,0,1,.318-15.139c1.449,1.842,4.257,5.24,6.281,6.588,2.833,1.89,14.809,10.756,19.533,12.646s11.337-1.259,14.17-7.557-1.259-20.468-5.039-31.489M54.283,124.552c-1.259-5.039-1.89-6.926-1.89-6.926s8.076-8.7,11.967-13.33c.525,12.442.854,26.045.489,28.052-.349,1.935-.168,6.147.226,10.041-2.1-2.881-9.709-13.5-10.792-17.838",
    transform: "translate(60.42 89.212)",
    fill: "#ffdbb3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276376",
    "data-name": "Path 276376",
    d: "M104.435,159.133q-8.622,0-21.188-.944c-13.559-1.022-16.292-5.022-17.171-7.945a35.519,35.519,0,0,1-.9-4.922l-6.658,8.255a.536.536,0,0,1-.422.2.543.543,0,0,1-.424-.2A189.587,189.587,0,0,0,44.179,138.83c-9.036-8.609-12.275-16.007-9.9-22.615,1.527-4.243,7.085-12.59,12.453-20.66C51.37,88.593,56.157,81.4,57.913,77.449c2.557-5.751,4.938-6.923,6.552-6.87a12.166,12.166,0,0,1,2.225-1.273c6.842-3.11,16.895-7.825,17-7.872a41.261,41.261,0,0,1,13.43-3.2c4.874-.232,9.2,1.784,13.369,3.727a53.49,53.49,0,0,0,5.4,2.284c.86.29,1.641.525,2.345.734,1.99.6,3.425,1.036,4.405,1.929a32.822,32.822,0,0,1,5.871,5.148l1.133,1.133c2.875,2.881,12.579,13.24,15.714,16.593a57.425,57.425,0,0,0-.578-5.734c-.494-3.2-4.1-27.385-4.1-28.421,0-.31,0-1.253,7.825-5.82a.489.489,0,0,1,.128-.05,4.3,4.3,0,0,1,3.247.394,2.95,2.95,0,0,1,1.217,2.275c.29,2.9.891,8.93,4.7,20.029,5.714,16.666,7.308,26.8,5.016,31.891-2.85,6.328-9.664,9.924-14.865,7.836-3.749-1.5-11.822-7.205-16.646-10.611-1.318-.932-2.37-1.675-2.99-2.088a31.4,31.4,0,0,1-5.511-5.594,115.654,115.654,0,0,0-.243,13.648c.254,3.216.3,9.8.343,17.431.067,10.988.14,23.444.91,28.823a2.519,2.519,0,0,1-.717,2.163c-1.985,2.124-8.137,3.18-18.659,3.18M65.562,143.439a.559.559,0,0,1,.151.02.549.549,0,0,1,.388.461,42.054,42.054,0,0,0,1.016,6.016c.784,2.613,3.322,6.2,16.211,7.169,28.731,2.147,37.05.159,38.973-1.893a1.457,1.457,0,0,0,.435-1.267c-.779-5.455-.857-17.95-.924-28.971-.045-7.286-.087-14.176-.341-17.35a128.808,128.808,0,0,1,.321-15.211.546.546,0,0,1,.38-.489.523.523,0,0,1,.592.184c1.457,1.856,4.2,5.167,6.153,6.471.623.419,1.683,1.164,3.012,2.1,4.785,3.378,12.791,9.034,16.423,10.491,4.7,1.876,10.854-1.468,13.469-7.28,2.141-4.754.486-14.921-5.058-31.084-3.844-11.222-4.453-17.336-4.748-20.275a1.911,1.911,0,0,0-.748-1.491,3.271,3.271,0,0,0-2.284-.257c-3.266,1.909-6.94,4.333-7.233,4.949.031.863,3.378,23.435,4.1,28.147a52.593,52.593,0,0,1,.636,7.328.543.543,0,0,1-.343.505.556.556,0,0,1-.6-.14c-.131-.137-13.257-14.2-16.674-17.618l-1.133-1.136a32.531,32.531,0,0,0-5.751-5.047,10.851,10.851,0,0,0-4.073-1.756c-.709-.212-1.5-.452-2.37-.745a52.494,52.494,0,0,1-5.522-2.328c-4.051-1.887-8.232-3.841-12.858-3.626a40.961,40.961,0,0,0-13.025,3.1c-.092.045-10.15,4.757-17,7.872a10.976,10.976,0,0,0-2.18,1.27.522.522,0,0,1-.4.109c-.857-.126-3.018.307-5.647,6.217-1.792,4.028-6.393,10.949-11.264,18.265-5.335,8.017-10.854,16.311-12.333,20.426-2.219,6.158.93,13.182,9.623,21.464a186.421,186.421,0,0,1,13.159,14.332l7.046-8.735a.541.541,0,0,1,.424-.2m-.137-.156a.542.542,0,0,1-.438-.223c-2.278-3.118-9.782-13.634-10.884-18.028-1.234-4.947-1.87-6.867-1.876-6.884a.542.542,0,0,1,.117-.542c.081-.092,8.109-8.743,11.948-13.31a.569.569,0,0,1,.592-.167.544.544,0,0,1,.368.5c.528,12.425.863,26.1.483,28.17a45.878,45.878,0,0,0,.229,9.888.536.536,0,0,1-.346.561.516.516,0,0,1-.193.039M55.161,124.769c.907,3.635,6.577,11.892,9.544,16.04a39.984,39.984,0,0,1-.039-8.21c.346-1.9.036-14.823-.441-26.542-3.677,4.268-9.662,10.748-10.868,12.054.223.715.818,2.722,1.8,6.658",
    transform: "translate(60.069 88.864)",
    fill: "#515255"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276377",
    "data-name": "Path 276377",
    d: "M46.356,75.57a.42.42,0,0,1-.232-.073.408.408,0,0,1-.1-.567,64.659,64.659,0,0,0,5.139-9.38.4.4,0,0,1,.539-.207.409.409,0,0,1,.207.539,65.751,65.751,0,0,1-5.215,9.511.406.406,0,0,1-.335.176",
    transform: "translate(82.321 117.001)",
    fill: "#515255"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276378",
    "data-name": "Path 276378",
    d: "M48.1,70.414a.41.41,0,0,1-.265-.72,11.9,11.9,0,0,0,2.94-3.81.394.394,0,0,1,.533-.212.4.4,0,0,1,.215.533,12.472,12.472,0,0,1-3.157,4.112.415.415,0,0,1-.265.1",
    transform: "translate(85.447 117.587)",
    fill: "#515255"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276379",
    "data-name": "Path 276379",
    d: "M78.447,75.047a.534.534,0,0,1-.385-.159,14.174,14.174,0,0,1-4.455-10.064.57.57,0,0,1,.57-.514.547.547,0,0,1,.516.569,13.336,13.336,0,0,0,4.137,9.24.543.543,0,0,1,0,.768.537.537,0,0,1-.382.159",
    transform: "translate(131.863 115.217)",
    fill: "#515255"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276380",
    "data-name": "Path 276380",
    d: "M76.467,75.447A.546.546,0,0,1,76,75.17,14.274,14.274,0,0,1,74.1,66.595a.532.532,0,0,1,.62-.455.543.543,0,0,1,.455.62,13.417,13.417,0,0,0,1.761,7.872.543.543,0,0,1-.2.743.563.563,0,0,1-.271.073",
    transform: "translate(132.624 118.478)",
    fill: "#515255"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276381",
    "data-name": "Path 276381",
    d: "M45.827,75.716a.424.424,0,0,1-.282-.112c-.042-.039-2.3-2.041-7.68-1.139a.409.409,0,1,1-.134-.807c5.843-.966,8.274,1.259,8.377,1.351a.41.41,0,0,1-.282.706",
    transform: "translate(66.985 131.53)",
    fill: "#515255"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276382",
    "data-name": "Path 276382",
    d: "M36.659,74.721a.409.409,0,0,1-.346-.623c.073-.117,1.842-2.78,8.087-.807a.408.408,0,0,1,.268.514.432.432,0,0,1-.511.268c-5.594-1.764-7.138.441-7.155.463a.408.408,0,0,1-.343.184",
    transform: "translate(64.948 130.007)",
    fill: "#515255"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276383",
    "data-name": "Path 276383",
    d: "M65.657,71.671a.41.41,0,0,1-.352-.617c1.287-2.191,5.586-9.374,6.92-9.709a.41.41,0,0,1,.491.3.406.406,0,0,1-.293.494c-.684.223-3.442,4.344-5.907,8.472l12.048-3.233a.409.409,0,1,1,.212.79L65.763,71.657a.459.459,0,0,1-.106.014",
    transform: "translate(116.898 109.886)",
    fill: "#515255"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276384",
    "data-name": "Path 276384",
    d: "M54.917,66.058s2.437,3.35,7.92,1.828,7.311-7.311,6.4-10.965-19.189-.611-14.315,9.137",
    transform: "translate(96.91 99.297)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276385",
    "data-name": "Path 276385",
    d: "M60.426,69.18a6.954,6.954,0,0,1-5.6-2.457.325.325,0,0,1-.047-.078c-1.636-3.263-.69-5.622.394-7.026,2.766-3.593,9.276-4.9,12.556-4.212,1.7.357,2.233,1.136,2.381,1.728.952,3.816-.871,9.98-6.781,11.621a10.743,10.743,0,0,1-2.9.424m-4.7-3.065c.274.341,2.512,2.928,7.311,1.594,5.243-1.454,6.862-6.923,6.013-10.312-.1-.4-.664-.74-1.547-.924-2.912-.606-9,.595-11.473,3.808-1.287,1.672-1.39,3.635-.3,5.834",
    transform: "translate(96.561 98.951)",
    fill: "#515255"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276386",
    "data-name": "Path 276386",
    d: "M55.263,52.729S51.586,55.18,51.1,57.385s.734,9.31,1.714,11.758,4.165,8.087,4.165,8.087S68,70.86,68.738,70.368s8.576,3.919,10.29,3.185-4.165-15.68-6.859-18.865-12.986-4.9-16.906-1.96",
    transform: "translate(91.345 91.754)",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276387",
    "data-name": "Path 276387",
    d: "M57.324,78.105a.5.5,0,0,1-.142-.02.566.566,0,0,1-.332-.257c-.131-.232-3.21-5.695-4.2-8.149C51.665,67.2,50.4,59.932,50.911,57.6c.525-2.348,4.1-4.793,4.386-4.983,4.112-3.062,14.773-1.329,17.632,2.052,2.588,3.06,7.878,16.244,7.236,18.949a1.02,1.02,0,0,1-.578.768c-1.108.486-3.47-.449-6.937-1.923A21.54,21.54,0,0,0,69.3,71.21c-1.239.776-11.267,6.569-11.705,6.823a.557.557,0,0,1-.274.073M61.69,52.079A9.938,9.938,0,0,0,55.936,53.5l-.025.017c-.971.65-3.573,2.691-3.936,4.321-.444,2,.678,8.913,1.689,11.443.79,1.974,3.079,6.128,3.864,7.537,3.914-2.261,10.706-6.2,11.256-6.566.5-.332,1.306-.053,4.291,1.214,1.985.846,5.31,2.253,6.086,1.923.7-1.231-4.157-14.58-7.06-18.014-1.641-1.937-6.306-3.294-10.41-3.294m-6.08.983h0Z",
    transform: "translate(90.998 91.421)",
    fill: "#515255"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276388",
    "data-name": "Path 276388",
    d: "M51.816,48.861s.246,3.919.734,9.8S55,69.2,58.186,71.891s7.839,4.165,9.064,2.694,2.7-7.593,2.205-11.27S68.23,51.8,68.23,51.8Z",
    transform: "translate(92.832 87.538)",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276389",
    "data-name": "Path 276389",
    d: "M65.952,76.062c-2.163,0-5.41-1.41-7.769-3.409-3.3-2.792-5.318-7.493-5.829-13.6-.48-5.82-.729-9.773-.731-9.815a.54.54,0,0,1,.636-.567l16.414,2.942a.545.545,0,0,1,.447.483c.006.078.74,7.872,1.226,11.5.491,3.7-.946,10.03-2.328,11.688a2.359,2.359,0,0,1-1.686.762c-.123.011-.251.017-.38.017m-13.2-26.2c.089,1.376.321,4.7.687,9.1.477,5.728,2.412,10.292,5.446,12.858,2.267,1.918,5.483,3.28,7.353,3.135a1.41,1.41,0,0,0,.944-.374c1.089-1.306,2.557-7.278,2.082-10.848-.422-3.16-1.03-9.458-1.189-11.124Z",
    transform: "translate(92.483 87.188)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87886",
    "data-name": "Group 87886",
    transform: "translate(144.647 136.399)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87885",
    "data-name": "Group 87885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87884",
    "data-name": "Group 87884",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276390",
    "data-name": "Path 276390",
    d: "M68.924,58.726c-.363-3.422-.692-6.926-.692-6.926l-16.417-2.94s.246,3.919.737,9.8a25.271,25.271,0,0,0,1.859,7.917Z",
    transform: "translate(-51.818 -48.861)",
    fill: "#fd930d"
  }))))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276391",
    "data-name": "Path 276391",
    d: "M52.788,47.9s-3.674-3.676-4.411-.491,2.205,8.087,6.37,6.862v-2.94Z",
    transform: "translate(86.469 82.616)",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276392",
    "data-name": "Path 276392",
    d: "M53.8,55.356a5.051,5.051,0,0,1-3.5-1.466,7.026,7.026,0,0,1-2.1-6.25,1.965,1.965,0,0,1,1.32-1.653c1.577-.469,3.76,1.639,4,1.882a.5.5,0,0,1,.087.114l1.96,3.428a.539.539,0,0,1,.073.271v2.94a.544.544,0,0,1-.391.519,5.081,5.081,0,0,1-1.452.215M50.02,47a.743.743,0,0,0-.2.028c-.262.075-.449.363-.564.851A5.98,5.98,0,0,0,51.039,53.1a3.923,3.923,0,0,0,3.515,1.094V51.827L52.7,48.586A5.311,5.311,0,0,0,50.02,47",
    transform: "translate(86.122 82.268)",
    fill: "#515255"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87889",
    "data-name": "Group 87889",
    transform: "translate(134.192 128.186)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87888",
    "data-name": "Group 87888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87887",
    "data-name": "Group 87887",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276393",
    "data-name": "Path 276393",
    d: "M52.788,47.9s-3.674-3.676-4.411-.491,2.205,8.087,6.37,6.862v-2.94Z",
    transform: "translate(-47.723 -45.571)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276394",
    "data-name": "Path 276394",
    d: "M53.8,55.356a5.051,5.051,0,0,1-3.5-1.466,7.026,7.026,0,0,1-2.1-6.25,1.965,1.965,0,0,1,1.32-1.653c1.577-.469,3.76,1.639,4,1.882a.5.5,0,0,1,.087.114l1.96,3.428a.539.539,0,0,1,.073.271v2.94a.544.544,0,0,1-.391.519,5.081,5.081,0,0,1-1.452.215M50.02,47a.743.743,0,0,0-.2.028c-.262.075-.449.363-.564.851A5.98,5.98,0,0,0,51.039,53.1a3.923,3.923,0,0,0,3.515,1.094V51.827L52.7,48.586A5.311,5.311,0,0,0,50.02,47",
    transform: "translate(-48.07 -45.918)",
    fill: "#515255"
  }))))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276395",
    "data-name": "Path 276395",
    d: "M50.132,59.375s6.125,16.414,11.515,19.6S77.816,85.1,80.758,73.584s-4.9-28.175-7.6-33.074-12.741-6.37-19.111-1.471-7.839,9.556-3.919,20.337",
    transform: "translate(85.94 64.529)",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276396",
    "data-name": "Path 276396",
    d: "M71.491,82.727a20.187,20.187,0,0,1-9.759-2.934c-5.494-3.247-11.5-19.2-11.75-19.879v-.006c-3.83-10.53-2.833-15.619,4.1-20.951a16.366,16.366,0,0,1,12.984-2.8c3.23.676,5.756,2.292,6.934,4.436.449.821,11.024,20.25,7.646,33.471-1.022,4-3.046,6.652-6.019,7.886a10.691,10.691,0,0,1-4.134.773M51,59.532C51.06,59.7,57.12,75.8,62.285,78.855c3.582,2.119,8.872,3.771,12.925,2.1,2.638-1.1,4.45-3.5,5.382-7.152,3.269-12.81-7.1-31.874-7.548-32.681-1.022-1.862-3.283-3.28-6.2-3.891a15.221,15.221,0,0,0-12.1,2.591C48.966,44.262,46.934,48.346,51,59.532",
    transform: "translate(85.579 64.182)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87892",
    "data-name": "Group 87892",
    transform: "translate(133.91 100.552)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87891",
    "data-name": "Group 87891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87890",
    "data-name": "Group 87890",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276397",
    "data-name": "Path 276397",
    d: "M56.89,45.475a20.98,20.98,0,0,1,8.283-1.932L71.286,38.4c-4.02-3.1-11.906-3.464-17.235.634-6.37,4.9-7.839,9.556-3.919,20.334,0,0,6.125,16.417,11.515,19.6a21.939,21.939,0,0,0,6.144,2.459c-2.6-3.347-6.6-8.671-7.864-11.384C58,65.9,57.167,57.348,54.682,52.376s-1.658-4.969,2.208-6.9",
    transform: "translate(-47.97 -36.02)",
    fill: "#fd930d"
  }))))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276398",
    "data-name": "Path 276398",
    d: "M56.624,49.522a3.4,3.4,0,0,1-1.033-.154.543.543,0,1,1,.343-1.03,2.055,2.055,0,0,0,1.893-.357c.355-.355-.4-2.658-1.56-4.74a.543.543,0,1,1,.949-.528c.8,1.432,2.526,4.891,1.379,6.038a2.726,2.726,0,0,1-1.971.77",
    transform: "translate(98.93 76.028)",
    fill: "#515255"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276399",
    "data-name": "Path 276399",
    d: "M52.427,46.04a1.315,1.315,0,0,1-.179-.014,1.092,1.092,0,0,1-.9-1.253,4.955,4.955,0,0,1,5.24-3.85,1.087,1.087,0,1,1,0,2.175c-2.722,0-3.076,1.951-3.09,2.035a1.092,1.092,0,0,1-1.075.907",
    transform: "translate(91.975 73.316)",
    fill: "#515255"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276400",
    "data-name": "Path 276400",
    d: "M54.23,45.531a4.2,4.2,0,0,1-1.586-.324.545.545,0,0,1,.447-.994,2.737,2.737,0,0,0,1.9.089,2.022,2.022,0,0,0,1.047-1.248.55.55,0,0,1,.7-.324.54.54,0,0,1,.321.7,2.871,2.871,0,0,1-2.822,2.1",
    transform: "translate(93.74 76.496)",
    fill: "#515255"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276401",
    "data-name": "Path 276401",
    d: "M58.44,44.829a4.229,4.229,0,0,1-1.586-.324.546.546,0,0,1-.271-.72.533.533,0,0,1,.72-.274A2.73,2.73,0,0,0,59.2,43.6a2.014,2.014,0,0,0,1.047-1.248.551.551,0,0,1,.7-.324.541.541,0,0,1,.324.7,2.871,2.871,0,0,1-2.825,2.1",
    transform: "translate(101.287 75.239)",
    fill: "#515255"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276402",
    "data-name": "Path 276402",
    d: "M56.628,43.179a1.089,1.089,0,0,1-.743-1.884,4.8,4.8,0,0,1,6.384-.3,1.087,1.087,0,1,1-1.231,1.792c-1.4-.958-2.563-.924-3.668.106a1.09,1.09,0,0,1-.743.29",
    transform: "translate(99.504 71.526)",
    fill: "#515255"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276403",
    "data-name": "Path 276403",
    d: "M81.176,68.687c-2.856-1.253-9.642-3.995-11.94-2.845C66.3,67.311,58.7,72.455,58.7,76.378c0,0-4.9-6.616-4.9-9.067s1.96-3.185.246-6.37-4.165-3.428-3.431-7.1c.681-3.4,7.445-7.01,10.778-7.526a11.04,11.04,0,0,0,7.353,2.627c5.41,0,9.8-3.456,9.8-7.719s-4.388-7.716-9.8-7.716a12.143,12.143,0,0,0-3.556.53c-5.134-.377-6.1,3.428-9.667,5.508-3.654,2.133-5.787,8.224-5.787,8.224l.148-.031c-2.593,3.791-2.585,8.375.24,16.149,0,0,6.127,16.414,11.515,19.6s16.172,6.125,19.111-5.391a26.4,26.4,0,0,0,.424-9.4",
    transform: "translate(85.946 60.021)",
    fill: "#515255"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276404",
    "data-name": "Path 276404",
    d: "M71.471,87.234A20.177,20.177,0,0,1,61.711,84.3c-5.494-3.247-11.5-19.2-11.75-19.879-2.766-7.607-2.9-12.369-.424-16.278a.491.491,0,0,1,.031-.209c.089-.257,2.244-6.309,6.024-8.514a14.613,14.613,0,0,0,2.9-2.412c1.681-1.675,3.45-3.422,6.976-3.177a12.622,12.622,0,0,1,3.621-.525c5.7,0,10.34,3.707,10.34,8.26s-4.637,8.26-10.34,8.26a11.738,11.738,0,0,1-7.512-2.585c-3.2.614-9.48,4.023-10.083,7.049-.427,2.113.293,2.9,1.385,4.087a12.549,12.549,0,0,1,1.99,2.652,4.678,4.678,0,0,1,.285,4.642,5.164,5.164,0,0,0-.469,1.988c0,1.58,2.487,5.466,4.056,7.71,1.351-3.975,8-8.369,10.594-9.664,2.426-1.217,8.807,1.256,12.4,2.833a.546.546,0,0,1,.321.438,26.853,26.853,0,0,1-.438,9.6c-1.022,4-3.046,6.652-6.019,7.886a10.7,10.7,0,0,1-4.134.773M50.743,47.9a.544.544,0,0,1-.061.489c-2.5,3.649-2.415,8.185.3,15.655.059.159,6.119,16.264,11.284,19.318,3.582,2.119,8.872,3.774,12.925,2.1,2.638-1.1,4.45-3.5,5.382-7.149a25.487,25.487,0,0,0,.444-8.9c-5.508-2.387-9.776-3.436-11.191-2.733C66.814,68.185,59.59,73.212,59.59,76.724a.547.547,0,0,1-.371.516.534.534,0,0,1-.609-.193C58.1,76.356,53.6,70.217,53.6,67.66a6.192,6.192,0,0,1,.542-2.381,3.645,3.645,0,0,0-.232-3.73,11.644,11.644,0,0,0-1.831-2.437c-1.172-1.276-2.186-2.381-1.653-5.033.743-3.707,7.825-7.428,11.23-7.956a.532.532,0,0,1,.444.131,10.554,10.554,0,0,0,6.99,2.49c5.1,0,9.257-3.221,9.257-7.177s-4.154-7.174-9.257-7.174a11.474,11.474,0,0,0-3.4.511.965.965,0,0,1-.2.022c-3.14-.226-4.57,1.195-6.231,2.853a15.335,15.335,0,0,1-3.118,2.579c-2.92,1.7-4.868,6.186-5.4,7.543",
    transform: "translate(85.599 59.672)",
    fill: "#515255"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276405",
    "data-name": "Path 276405",
    d: "M58.3,49.8a5.167,5.167,0,0,1-3.322-1.3.544.544,0,1,1,.692-.84,4.034,4.034,0,0,0,3.1,1.027c2.256-.3,3.933-2.613,3.95-2.638a.543.543,0,1,1,.882.634c-.078.112-1.974,2.722-4.687,3.079a4.645,4.645,0,0,1-.617.042",
    transform: "translate(98.149 82.091)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276406",
    "data-name": "Path 276406",
    d: "M50.2,83.23a14.642,14.642,0,0,1,3.78,3.464,61.443,61.443,0,0,0,4.092,5.036s3.464.315,3.149,1.89-.946,2.518-2.521,2.518-5.036-3.146-5.036-3.146l-5.039,7.869s-4.723-3.462-6.3-7.869Z",
    transform: "translate(75.835 149.112)",
    fill: "#fff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276407",
    "data-name": "Path 276407",
    d: "M48.975,101.756a.54.54,0,0,1-.321-.106c-.2-.142-4.877-3.612-6.488-8.126A.537.537,0,0,1,42.256,93l7.869-9.762a.535.535,0,0,1,.712-.12,14.9,14.9,0,0,1,3.942,3.623,57.307,57.307,0,0,0,3.911,4.821c.65.081,2.445.388,3.143,1.323A1.47,1.47,0,0,1,62.1,94.08c-.254,1.27-.849,2.954-3.051,2.954-1.413,0-3.861-1.954-4.922-2.864l-4.7,7.339a.544.544,0,0,1-.357.24.61.61,0,0,1-.1.008M43.3,93.443c1.287,3.28,4.374,6.019,5.541,6.971l4.718-7.367a.548.548,0,0,1,.824-.109c1.279,1.164,3.679,3.009,4.673,3.009,1.142,0,1.678-.567,1.982-2.082a.374.374,0,0,0-.075-.327,4.688,4.688,0,0,0-2.588-.913.551.551,0,0,1-.355-.179,60.359,60.359,0,0,1-4.143-5.1,13.148,13.148,0,0,0-3.213-3.037Z",
    transform: "translate(75.487 148.761)",
    fill: "#515255"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276408",
    "data-name": "Path 276408",
    d: "M84.76,123.248a46.428,46.428,0,1,1,46.427-46.427A46.481,46.481,0,0,1,84.76,123.248m0-90.681a44.253,44.253,0,1,0,44.252,44.255A44.3,44.3,0,0,0,84.76,32.567",
    transform: "translate(68.672 54.449)",
    fill: "#515255"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276409",
    "data-name": "Path 276409",
    d: "M73.059,43.878s-3.149-.315-3.78,1.574-1.572,3.78-1.572,5.039.313,2.2,1.887,2.518,2.521-1.89,2.521-1.89Z",
    transform: "translate(121.303 78.574)",
    fill: "#fff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276410",
    "data-name": "Path 276410",
    d: "M70.263,53.935a2.251,2.251,0,0,1-.424-.042,2.689,2.689,0,0,1-2.325-3.051,11.113,11.113,0,0,1,.971-3.5c.215-.558.438-1.136.634-1.717.759-2.281,4.2-1.954,4.346-1.946a.553.553,0,0,1,.371.2.541.541,0,0,1,.114.41L73,51.543a.633.633,0,0,1-.039.142c-.042.1-.985,2.25-2.7,2.25m2.529-9.179c-.826.02-2.3.2-2.644,1.22-.2.592-.427,1.186-.648,1.761a10.608,10.608,0,0,0-.9,3.1c0,1.122.226,1.739,1.454,1.985,1,.234,1.734-1.2,1.882-1.51Z",
    transform: "translate(120.954 78.226)",
    fill: "#515255"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276411",
    "data-name": "Path 276411",
    d: "M70.861,43.3s-1.574,8.5-1.574,11.021a9.543,9.543,0,0,0,1.89,5.351,3.943,3.943,0,0,0,2.2,1.259l1.574-1.887s-1.887,2.518.631,5.667,4.408,2.833,6.613,1.89,2.833-2.205,1.887-5.67-1.574-9.131-2.2-12.593-2.833-4.723-4.1-4.723-4.721-1.259-6.926-.315",
    transform: "translate(124.132 76.948)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276412",
    "data-name": "Path 276412",
    d: "M80.032,68.143c-1.371,0-2.856-.653-4.525-2.739a5.845,5.845,0,0,1-1.421-3.71.61.61,0,0,1-.463.123,4.379,4.379,0,0,1-2.552-1.491,10.128,10.128,0,0,1-1.979-5.656c0-2.54,1.519-10.767,1.586-11.116a.529.529,0,0,1,.318-.4c1.7-.731,3.975-.29,5.631.036a10.047,10.047,0,0,0,1.513.234c1.482,0,3.936,1.376,4.626,5.167.215,1.178.427,2.607.653,4.118a83.55,83.55,0,0,0,1.541,8.431c.969,3.551.394,5.2-2.2,6.312a6.961,6.961,0,0,1-2.73.692M75.3,58.853a.552.552,0,0,1,.338.117.543.543,0,0,1,.1.754c-.064.087-1.591,2.236.62,5,2.373,2.965,3.972,2.582,5.977,1.731,1.823-.787,2.482-1.7,1.577-5.028a83.127,83.127,0,0,1-1.569-8.559c-.226-1.5-.435-2.914-.648-4.078-.567-3.118-2.484-4.282-3.556-4.282a10.08,10.08,0,0,1-1.722-.251c-1.424-.276-3.347-.65-4.726-.2a104.3,104.3,0,0,0-1.513,10.619,8.987,8.987,0,0,0,1.8,5.05,3.008,3.008,0,0,0,1.555.949l1.357-1.625a.535.535,0,0,1,.416-.193",
    transform: "translate(123.783 76.6)",
    fill: "#515255"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276413",
    "data-name": "Path 276413",
    d: "M69.649,49.989a.274.274,0,0,1-.262-.2,2.14,2.14,0,0,1,.243-1.647,2.365,2.365,0,0,1,1.8-.932c2.378-.282,6.292-.7,6.292-.7l.059.539s-3.911.422-6.287.7a1.884,1.884,0,0,0-1.413.692,1.606,1.606,0,0,0-.173,1.2.274.274,0,0,1-.19.335.3.3,0,0,1-.073.011",
    transform: "translate(124.189 83.327)",
    fill: "#515255"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276414",
    "data-name": "Path 276414",
    d: "M69.712,47.049a.272.272,0,0,1-.067-.536c.226-.059,5.522-1.421,7.512-1.128a.273.273,0,0,1-.075.542c-1.856-.251-7.247,1.1-7.3,1.114a.276.276,0,0,1-.067.008",
    transform: "translate(124.405 81.237)",
    fill: "#515255"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276415",
    "data-name": "Path 276415",
    d: "M69.861,45.273a.271.271,0,0,1-.047-.539,37,37,0,0,1,6.217-.567.274.274,0,0,1-.02.547h-.02a35.165,35.165,0,0,0-6.083.553l-.047.006",
    transform: "translate(124.674 79.1)",
    fill: "#515255"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276416",
    "data-name": "Path 276416",
    d: "M72.925,49.58a3.907,3.907,0,0,1-2.6-1,.272.272,0,1,1,.382-.388,3.376,3.376,0,0,0,2.967.762.291.291,0,0,1,.324.212.277.277,0,0,1-.209.324,4.341,4.341,0,0,1-.86.092",
    transform: "translate(125.84 86.199)",
    fill: "#515255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3ResumeBuildingDashboard);
export default __webpack_public_path__ + "static/media/3_Resume_Building_Dashboard.38efb0454eacaf894d58835b1af0af62.svg";
export { ForwardRef as ReactComponent };